<template>
  <div class="app-container">
    <div class="navbar-group">
      <el-button type="primary" @click.native="RestartOrder" :disabled="!canWrite">新增</el-button>
      <!-- 选单 -->
      <el-dropdown style="margin-left: 4px" :disabled="data.Status == 2 || !canWrite">
        <el-button type="primary"> 单据选择<i class="el-icon-arrow-down el-icon--right"></i> </el-button>
        <el-dropdown-menu slot="dropdown" style="margin-left: 4px">
          <el-dropdown-item class="dropdown-item" @click.native="openDialog('销售订单')"> 销售订单 </el-dropdown-item>
          <el-dropdown-item class="dropdown-item" @click.native="openDialog('发货通知单')"> 发货通知单 </el-dropdown-item>
          <el-dropdown-item class="dropdown-item" @click.native="openDialog('销售出库单')"> 销售出库单 </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-badge is-dot :hidden="!isEdit">
        <el-button type="primary" @click.native="save" :disabled="(data.Status == 2 && !is_orderUpdateStatus) || !canWrite">保存</el-button>
      </el-badge>
      <el-button type="primary" @click.native="orderUpdate" :disabled="data.Status != 2 || !canWrite">变更</el-button>
      <el-button type="primary" @click.native="orderDel" :disabled="!isSave || data.Status == 2 || !canWrite">删除</el-button>
      <el-button type="primary" @click.native="orderReview" :disabled="!isSave || !canReview">{{ ReviewName }}</el-button>
      <!-- 联查 -->
      <el-dropdown>
        <el-button type="primary" :disabled="!isSave"> 联查<i class="el-icon-arrow-down el-icon--right"></i> </el-button>
        <el-dropdown-menu slot="dropdown" style="margin-left: 4px">
          <el-dropdown-item class="dropdown-item" @click.native="goJump(1)">销售发票</el-dropdown-item>
          <el-dropdown-item class="dropdown-item" @click.native="goJump(2)">销售出库单</el-dropdown-item>
          <el-dropdown-item class="dropdown-item" @click.native="goJump(3)">收款单</el-dropdown-item>
          <el-dropdown-item class="dropdown-item" @click.native="goJump(4)">销售订单</el-dropdown-item>
          <!-- <el-dropdown-item class="dropdown-item">退货情况</el-dropdown-item>
          <el-dropdown-item class="dropdown-item">凭证情况</el-dropdown-item> -->
        </el-dropdown-menu>
      </el-dropdown>
      <el-button type="primary" @click="print(data)" :disabled="!isSave">打印</el-button>
      <el-button type="primary" @click="openSetField">明细字段</el-button>
    </div>
    <el-form :inline="true" :model="data" :line-form="true" label-width="90px" ref="ruleForm" :rules="rules" status-icon>
      <!-- 表头 -->
      <el-row>
        <!-- 单据日期 -->
        <el-form-item label="单据日期:" prop="DocDate" label-width="90px">
          <span class="not-edit" v-if="ReviewStatus">{{ $commonJs.toDateString(data.DocDate) }}</span>
          <el-date-picker
            v-else
            v-model="data.DocDate"
            type="date"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            placeholder="选择日期"
            style="width: 190px"
            :clearable="false"
            @change="val => previewNo(val)"
          />
        </el-form-item>
        <el-form-item label="单据编码:" prop="DocNo" label-width="90px">
          <span v-if="Mode == 0 || ReviewStatus" class="not-edit" style="min-width: 190px">{{ data.DocNo }}</span>
          <el-input v-else v-model="data.DocNo" placeholder="请输入单据编码" style="min-width: 190px" />
        </el-form-item>
        <el-form-item label="业务类型:" label-width="90px">
          <span class="not-edit" style="width: 190px" v-if="ReviewStatus">{{ data.BusinessType }}</span>
          <el-select v-else v-model="data.BusinessTypeId" style="width: 190px">
            <el-option @click.native="BusinessChange(item)" v-for="item in businessTypeList" :key="item.BusinessTypeId" :label="item.BusinessType" :value="item.BusinessTypeId"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客户:" prop="TradeUnitId" label-width="90px">
          <span class="not-edit" v-if="ReviewStatus">{{ data.FullName }}</span>
          <el-select v-else v-model="data.TradeUnitId" :disabled="isSelect" filterable style="width: 190px">
            <el-option v-for="item in tradeUnitList" :key="item.TradeUnitId" :value="item.TradeUnitId" :label="item.FullName" @click.native="setTradeunit(item)"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客户编码:" prop="TradeUnitNo" label-width="90px">
          <span class="not-edit" v-if="ReviewStatus">{{ data.TradeUnitNo }}</span>
          <el-select v-else v-model="data.TradeUnitId" :disabled="isSelect" filterable style="width: 190px">
            <el-option v-for="item in tradeUnitList" :key="item.TradeUnitId" :value="item.TradeUnitId" :label="item.TradeUnitNo" @click.native="setTradeunit(item)"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="收款方式:" label-width="90px">
          <template v-if="ReviewStatus">
            <span class="not-edit" v-if="data.SettleId === 1">全额定金</span>
            <span class="not-edit" v-else-if="data.SettleId === 2">全额现结</span>
            <span class="not-edit" v-else-if="data.SettleId === 3">限期付款</span>
            <span class="not-edit" v-else-if="data.SettleId === 4">月结</span>
            <span class="not-edit" v-else-if="data.SettleId === 5">其他</span>
            <span class="not-edit" v-else></span>
          </template>
          <el-select v-else v-model="data.SettleId" style="width: 190px" clearable>
            <el-option :value="1" label="全额定金" />
            <el-option :value="2" label="全额现结" />
            <el-option :value="3" label="限期付款" />
            <el-option :value="4" label="月结" />
            <el-option :value="5" label="其他" />
          </el-select>
        </el-form-item>
        <el-form-item label="收款到期日:" label-width="90px">
          <span class="not-edit" v-if="ReviewStatus">{{ data.ExpiringDate }}</span>
          <el-date-picker v-else v-model="data.ExpiringDate" value-format="yyyy-MM-dd" format="yyyy-MM-dd" type="date" placeholder="选择日期" style="width: 190px"> </el-date-picker>
        </el-form-item>
        <el-form-item label="现结金额:" label-width="90px" :prop="data.SettleId === 2 ? 'ReceiptAmount' : ''" v-if="canPrice">
          <span class="not-edit" v-if="ReviewStatus">{{ data.ReceiptAmount }}</span>
          <select-input v-else placeholder="请输入金额" v-model="data.ReceiptAmount" @click="openAmount" style="width: 190px" @clear="clear" />
        </el-form-item>
        <el-form-item label="票据类型:" label-width="90px">
          <span class="not-edit" v-if="ReviewStatus">{{ data.InvoiceTypeName }}</span>
          <invoice-select v-else @getInvoiceTypeValue="getInvoiceType" v-model="data.InvoiceTypeId" style="width: 190px"></invoice-select>
        </el-form-item>
        <el-form-item label="仓库:" label-width="90px" prop="WarehouseId">
          <span class="not-edit" style="width: 190px" v-if="ReviewStatus">{{ data.WarehouseName }}</span>
          <!-- <wms-select v-else v-model="data.WarehouseId" style="width: 190px"></wms-select> -->
          <el-select v-else style="width: 190px" v-model="data.WarehouseId" @change="changeDataWarehouse">
            <el-option v-for="item in warehouseList" :key="item.key" :label="item.label" :value="item.value"> </el-option>
          </el-select>
        </el-form-item>
        <!-- 经手人 -->
        <el-form-item label="经手人:" prop="EmpId" label-width="90px">
          <span class="not-edit" v-if="ReviewStatus">{{ data.EmpName }}</span>
          <select-input v-else placeholder="请选择经办人" :label="data.EmpName" v-model="data.EmpId" @click="openEmp" style="width: 190px" />
        </el-form-item>
        <el-form-item label="金额汇总:" label-width="90px" v-if="canPrice">
          {{ tableAmountSum }}
        </el-form-item>
        <!-- 制单人 -->
        <el-form-item label="制单人:" label-width="90px">
          {{ data.MakeEmpName }}
        </el-form-item>
      </el-row>
      <!-- 表头-备注 -->
      <el-row>
        <el-col :span="24">
          <el-form-item label="备注:" label-width="80px">
            <span v-if="orderUpdateStatus">{{ data.Remark }}</span>
            <el-input v-else type="textarea" v-model="data.Remark" :autosize="{ minRows: 2, maxRows: 4 }" maxlength="60" placeholder="请填写备注信息" style="width: 600px" />
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 表体 -->
      <el-row style="padding: 10px" v-if="showDetail">
        <el-tabs v-model="activeName" @tab-click="handleClick" class="custom-tabs">
          <el-tab-pane label="明细" name="1">
            <el-table border :data="tableList" class="tableList" :row-class-name="tableRowClassName" @row-click="addColumn" v-keymove="addList" :summary-method="summaryFunc" show-summary>
              <insert-row @on-insert="onInsert" />
              <el-table-column min-width="160" align="left" label="备注" v-if="showField('备注')">
                <template slot-scope="{ row }">
                  <span v-if="ReviewStatus">{{ row.Remark }}</span>
                  <el-input v-else v-model="row.Remark" @change="editT(row)" placeholder="请输入备注" />
                </template>
              </el-table-column>
              <el-table-column label="仓库" prop="WarehouseId" min-width="120" key="table1_2" v-if="showField('仓库')">
                <template slot-scope="{ row, $index }">
                  <span v-if="ReviewStatus">{{ row.WarehouseName }}</span>
                  <el-select v-else v-model="row.WarehouseId" @change="changeWarehouse($event, row, $index)">
                    <el-option v-for="item in warehouseList" :key="item.key" :label="item.label" :value="item.value"> </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="WarehousePositionId" label="库位" min-width="120" v-if="showField('库位')">
                <template slot-scope="{ row }">
                  <el-select v-model="row.WarehousePositionId" @visible-change="onChangeWarehousePosition($event, row, row.WarehouseId)">
                    <el-option v-for="item in row.WarehousePositionList" :key="item.WarehousePositionId" :label="item.WarehousePositionName" :value="item.WarehousePositionId"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column align="left" label="存货名称" min-width="160px" v-if="showField('存货名称')">
                <template slot-scope="{ row, $index }">
                  <span v-if="!data.WarehouseId" style="color: #999">请先选择仓库</span>
                  <span v-else-if="ReviewStatus">{{ row.ProductName }}</span>
                  <account-select
                    v-else
                    v-model="row.ProductName"
                    :source="DAccount"
                    @select="onSelect($event, row, $index)"
                    :pageSize="pageParams.pageSize"
                    :pageIndex="pageParams.pageIndex"
                    :listTotal="listTotal"
                    @inputText="inputText"
                    @click.native="resetFun(row)"
                    @currentPage="currentPage($event, row)"
                    :pageType="true"
                  />
                </template>
              </el-table-column>
              <el-table-column align="left" label="存货编码" min-width="140px" v-if="showField('存货编码')">
                <template slot-scope="{ row }">
                  <span>{{ row.ProductNo }}</span>
                </template>
              </el-table-column>
              <el-table-column align="left" label="批号" min-width="120px" v-if="showField('批号')">
                <template slot-scope="{ row, $index }">
                  <span v-if="!row.ProductName" style="color: #999">请先选择存货</span>
                  <span v-else-if="ReviewStatus">{{ row.BatchNumber }}</span>
                  <span v-else-if="!row.IsBatchNumber" class="text-gray">该存货未启用批号</span>
                  <account-select
                    v-else
                    v-model="row.BatchNumber"
                    :Head="Head"
                    :source="batchList"
                    :listTotal="batchListTotal"
                    :pageType="true"
                    :pageSize="batchPageParams.pageSize"
                    :pageIndex="batchPageParams.pageIndex"
                    @select="onSelBatch($event, row, $index)"
                    @inputText="inputTextBatch($event, row)"
                    @click.native="onOpenBatch($event, row, $index)"
                    @currentPage="currentPageBatch($event, row)"
                    keyword="BatchNumber"
                  />
                </template>
              </el-table-column>
              <el-table-column align="left" label="规格型号" v-if="showField('规格型号')" min-width="100px">
                <template slot-scope="{ row }">
                  <span>{{ row.ProductSpec }}</span>
                </template>
              </el-table-column>
              <el-table-column align="left" label="属性" v-if="showField('属性')" min-width="150px">
                <template slot-scope="{ row, $index }">
                  <span v-if="ReviewStatus">{{ row.PropertyName }}</span>
                  <!-- <account-select
                v-else-if="row.UseProcess"
                v-model="row.PropertyName"
                :source="PropertyAccount"
                :Head="PropertyHead"
                @select="onPropertySelect($event, row, $index)"
                :pageSize="pagePropertyParams.pageSize"
                :pageIndex="pagePropertyParams.pageIndex"
                :listTotal="listPropertyTotal"
                @inputText="inputPropertyText"
                @click.native="resetPropertyFun(row)"
                @currentPage="currentPropertyPage($event, row)"
                :pageType="true"
                keyword="PropertyName"
              /> -->
                  <el-select filterable v-else-if="row.UseProcess && !ReviewStatus" v-model="row.PropertyId" @change="changeProperty($event, row, $index)">
                    <el-option v-for="item in propertyList" :key="item.PropertyId" :value="item.PropertyId" :label="item.PropertyName" :disabled="item.Status == 0" />
                  </el-select>
                  <span v-else>{{ row.PropertyName }}</span>
                </template>
              </el-table-column>
              <el-table-column align="left" label="颜色" min-width="120px" v-if="showField('颜色')">
                <template slot-scope="{ row, $index }">
                  <span v-if="row.isOrderData && !row.ColorId">{{ row.ColorName || '' }}</span>
                  <el-select v-else-if="row.UseColor && !ReviewStatus" v-model="row.ColorId" @change="changeColor($event, row, $index)">
                    <el-option v-for="item in colorList" :key="item.ColorId" :value="item.ColorId" :label="item.ColorName" :disabled="item.Status == 0" />
                  </el-select>
                  <span v-else>{{ row.ColorName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="存货条码" prop="BarCode" align="left" min-width="160" v-if="showField('存货条码')"> </el-table-column>
              <el-table-column label="装箱规格" prop="PackingSpeciId" align="left" min-width="100" v-if="showField('装箱规格')">
                <template slot-scope="{ row }">
                  <el-select v-model="row.PackingSpeciId" @change="changeSpeci($event, row)">
                    <el-option v-for="item in packingspeciList" :key="item.PackingSpeciId" :label="item.SpeciName" :value="item.PackingSpeciId" :disabled="item.Status == 0"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="每件数" prop="PackingNumber" align="left" min-width="100" v-if="showField('装箱数量')"></el-table-column>
              <el-table-column label="件数" prop="PackingQuantity" align="left" min-width="140" v-if="showField('件数')">
                <template slot-scope="{ row, $index }">
                  <span class="not-edit" v-if="ReviewStatus === 2">{{ $commonJs.toThousands(row.PackingQuantity) }}</span>
                  <el-input type="text" class="input-with-select" style="width: 100px" v-else @change="changePackingQuantity($event, row, $index)" v-model="row.PackingQuantity">
                    <!-- <el-button v-if="row.ProductName" style="width: 40px; border-left: 1px" slot="append" @click="openSales(row, $index)" icon="el-icon-s-order"></el-button> -->
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column align="left" label="销售单位" min-width="120px" v-if="showField('销售单位')">
                <template slot-scope="{ row, $index }">
                  <el-select v-if="row.Units && row.Units.length > 0 && !ReviewStatus && row.HasGrammage != true" v-model="row.SaUnitId">
                    <el-option v-for="item in row.Units" :key="item.UnitId" :value="item.UnitId" :label="item.UnitName" @click.native="compareSaUnit(item, row, $index)"></el-option>
                  </el-select>
                  <span v-else>{{ row.SaUnitName }}</span>
                </template>
                <!--  -->
              </el-table-column>
              <el-table-column align="right" prop="SaQuantity" label="数量" min-width="120px" v-if="showField('数量')">
                <template slot-scope="{ row, $index }">
                  <span v-if="ReviewStatus">{{ $commonJs.toThousands(row.SaQuantity) }}</span>
                  <el-input v-else v-quantity:[option]="option" type="text" v-model="row.SaQuantity" @change="changeQuantity($event, row, $index)"></el-input>
                </template>
              </el-table-column>
              <el-table-column align="right" label="可用量" v-if="showField('可用量')">
                <template slot-scope="{ row }">
                  <span>{{ $commonJs.toThousands(getQuantity(row.ExistQuantity)) }}</span>
                </template>
              </el-table-column>
              <el-table-column align="right" label="现存量" v-if="showField('现存量')">
                <template slot-scope="{ row }">
                  <span>{{ $commonJs.toThousands(getQuantity(row.ExistQuantity)) }}</span>
                </template>
              </el-table-column>
              <el-table-column align="left" label="计量单位2" min-width="120px" v-if="showField('计量单位2')">
                <template slot-scope="{ row, $index }">
                  <!-- <span>{{ row }}{{ $index }}</span> -->
                  <el-select v-if="row.Units && row.Units.length > 0 && !ReviewStatus && row.HasGrammage != true" v-model="row.UnitId2">
                    <el-option v-for="item in row.Units" :key="item.UnitId" :value="item.UnitId" :label="item.UnitName" @click.native="compareUnitId(item, row, $index)"></el-option>
                  </el-select>
                  <span v-else-if="row.UnitType == 0"></span>
                  <span v-else>{{ row.UnitName2 }}</span>
                </template>
              </el-table-column>
              <el-table-column align="right" prop="Quantity2" label="数量2" v-if="showField('数量2')">
                <template slot-scope="{ row, $index }">
                  <span v-if="ReviewStatus">{{ $commonJs.toThousands(row.Quantity2) }}</span>
                  <span v-else-if="row.UnitType == 0"></span>
                  <el-input v-else type="text" v-model.number="row.Quantity2" @input="changeQuantity2($event, row, $index)" @blur="getChangeQuantity($event, row, $index)" />
                </template>
              </el-table-column>
              <el-table-column align="right" label="换算率" v-if="showField('换算率')">
                <template slot-scope="{ row, $index }">
                  <span v-if="(ReviewStatus || row.ChangeType == 0) && row.UnitType == 1">{{ row.Rate }}</span>
                  <span v-else-if="row.UnitType == 0"></span>
                  <el-input v-else type="text" v-model="row.Rate" @input="RateChange($event, row, $index)"></el-input>
                </template>
              </el-table-column>
              <el-table-column align="right" label="最低售价" v-if="canPrice && showField('最低售价')">
                <template slot-scope="{ row }">
                  <span>{{ row.RetailPrice }}</span>
                </template>
              </el-table-column>
              <el-table-column align="right" label="报价" min-width="100px" v-if="canPrice && showField('报价')">
                <template slot-scope="{ row, $index }">
                  <span v-if="ReviewStatus">{{ row.QuotedPrice }}</span>
                  <el-input v-else v-price type="text" v-model="row.QuotedPrice" :disabled="row.IsGift" @change="changeQuotedPrice(row, $index)"> </el-input>
                </template>
              </el-table-column>
              <el-table-column align="right" label="折扣%" min-width="100px" v-if="canPrice && showField('折扣%')">
                <template slot-scope="{ row, $index }">
                  <span v-if="ReviewStatus">{{ row.Discount }}</span>
                  <el-input v-else v-decimals type="text" v-model="row.Discount" :disabled="row.IsGift" @input="changeDiscount(row, $index)" />
                </template>
              </el-table-column>
              <el-table-column align="right" label="税率%" min-width="100px" v-if="canPrice && showField('税率%')">
                <template slot-scope="{ row, $index }">
                  <span v-if="ReviewStatus">{{ row.TaxRate }}</span>
                  <el-input v-else v-decimals v-limit:value="{ max: 100, min: 0 }" type="text" v-model.number="row.TaxRate" :disabled="row.IsGift" @input="changeTaxRate(row, $index)"></el-input>
                </template>
              </el-table-column>
              <el-table-column align="right" label="单价" min-width="140px" v-if="canPrice && showField('单价')">
                <template slot-scope="{ row, $index }">
                  <span v-if="ReviewStatus">{{ row.Price }}</span>
                  <el-input v-else v-price type="text" v-model="row.Price" :disabled="row.IsGift" @change="changePrice(row, $index)">
                    <el-button v-if="row.ProductName" slot="append" @click="openSales(row, $index)" icon="el-icon-s-order"></el-button>
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column align="right" label="含税单价" min-width="100px" v-if="canPrice && showField('含税单价')">
                <template slot-scope="{ row, $index }">
                  <span v-if="ReviewStatus">{{ row.TaxPrice }}</span>
                  <el-input v-else v-price type="text" v-model="row.TaxPrice" :disabled="row.IsGift" @input="changeTaxPrice(row, $index)"></el-input>
                </template>
              </el-table-column>
              <el-table-column align="right" prop="Amount" label="金额" min-width="100px" v-if="canPrice && showField('金额')">
                <template slot-scope="{ row, $index }">
                  <span v-if="ReviewStatus">{{ $commonJs.toThousands(row.Amount) }}</span>
                  <el-input v-else v-decimals type="text" v-model="row.Amount" :disabled="row.IsGift" @input="changeAmount(row, $index)"></el-input>
                </template>
              </el-table-column>
              <el-table-column align="right" prop="TaxLimit" label="税额" min-width="100px" v-if="canPrice && showField('税额')">
                <template slot-scope="{ row, $index }">
                  <span v-if="ReviewStatus">{{ $commonJs.toThousands(row.TaxLimit) }}</span>
                  <el-input v-else v-decimals type="text" v-model="row.TaxLimit" :disabled="row.IsGift" @input="changeTaxLimit(row, $index)"></el-input>
                </template>
              </el-table-column>
              <el-table-column align="right" prop="TaxAmount" label="含税金额" min-width="100px" v-if="canPrice && showField('含税金额')">
                <template slot-scope="{ row, $index }">
                  <span v-if="ReviewStatus">{{ $commonJs.toThousands(row.TaxAmount) }}</span>
                  <el-input v-else v-decimals type="text" v-model="row.TaxAmount" :disabled="row.IsGift" @input="changeTaxAmount(row, $index)"></el-input>
                </template>
              </el-table-column>
              <el-table-column align="right" prop="DiscountAmount" label="折扣金额" min-width="100px" v-if="canPrice && showField('折扣金额')">
                <template slot-scope="{ row, $index }">
                  <span v-if="ReviewStatus">{{ $commonJs.toThousands(row.DiscountAmount) }}</span>
                  <el-input v-else v-decimals type="text" v-model="row.DiscountAmount" :disabled="row.IsGift" @input="changeDiscountAmount(row, $index)"></el-input>
                </template>
              </el-table-column>
              <!--  -->
              <el-table-column align="right" label="成本价" v-if="canPrice && showField('成本价')">
                <template slot-scope="{ row }">
                  <el-input type="text" v-model="row.CostPrice"></el-input>
                </template>
              </el-table-column>
              <el-table-column align="right" label="成本金额" v-if="canPrice && showField('成本金额')">
                <template slot-scope="{ row }">
                  <span v-if="ReviewStatus">{{ $commonJs.toDateString(row.CostAmount) }}</span>
                  <el-input v-else type="text" v-model="row.CostAmount"></el-input>
                </template>
              </el-table-column>
              <!--  -->
              <el-table-column align="left" label="交货日期" min-width="180px" v-if="showField('交货日期')">
                <template slot-scope="{ row }">
                  <span v-if="ReviewStatus">{{ $commonJs.toDateString(row.DeliveryDate) }}</span>
                  <el-date-picker
                    v-else
                    v-model="row.DeliveryDate"
                    value-format="yyyy-MM-dd"
                    format="yyyy-MM-dd"
                    type="date"
                    placeholder="选择日期"
                    style="width: 140px"
                    @change="changeDeliveryDate(row)"
                  >
                  </el-date-picker>
                </template>
              </el-table-column>
              <el-table-column align="center" label="赠品" v-if="showField('赠品')">
                <template slot-scope="{ row }">
                  <el-checkbox @change="changeIsGift($event, row)" v-model="row.IsGift" :disabled="ReviewStatus"></el-checkbox>
                </template>
              </el-table-column>
              <el-table-column align="right" min-width="100px" label="累计出库数量" v-if="showField('累计出库数量')">
                <template slot-scope="{ row }">
                  <span>{{ $commonJs.toThousands(getQuantity(row.OutQuantity)) }}</span>
                </template>
              </el-table-column>
              <el-table-column align="right" min-width="100px" label="累计出库数量2" v-if="showField('累计出库数量2')">
                <template slot-scope="{ row }">
                  <span>{{ $commonJs.toThousands(getQuantity(row.OutQuantity2)) }}</span>
                </template>
              </el-table-column>
              <el-table-column align="right" label="累计开票数量" min-width="120px" v-if="showField('累计开票数量')">
                <template slot-scope="{ row }">
                  <span>{{ $commonJs.toThousands(getQuantity(row.InvoicedQuantity)) }}</span>
                </template>
              </el-table-column>
              <el-table-column align="right" label="累计开票数量2" min-width="120px" v-if="showField('累计开票数量2')">
                <template slot-scope="{ row }">
                  <span>{{ $commonJs.toThousands(getQuantity(row.InvoicedQuantity2)) }}</span>
                </template>
              </el-table-column>
              <el-table-column align="right" label="普通退货数量" min-width="100px" v-if="showField('普通退货数量')">
                <template slot-scope="{ row }">
                  <span>{{ $commonJs.toThousands(getQuantity(row.ReturnQuantity)) }}</span>
                </template>
              </el-table-column>
              <el-table-column align="right" label="累计结款金额" min-width="100px" v-if="canPrice && showField('累计结款金额')">
                <template slot-scope="{ row }">
                  <span>{{ $commonJs.toThousands(getQuantity(row.SettlementAmount)) }}</span>
                </template>
              </el-table-column>
              <el-table-column align="left" label="销售订单号" min-width="180px" v-if="showField('销售订单号')">
                <template slot-scope="{ row }">
                  <span>{{ row.OrderNo }}</span>
                </template>
              </el-table-column>
              <el-table-column align="left" label="来源单据" min-width="100px" v-if="showField('来源单据')">
                <template slot-scope="{ row }">
                  <span v-if="row.SourceType === 7">发货通知单</span>
                  <span v-if="row.SourceType === 6">销售订单</span>
                  <span v-if="row.SourceType === 17">销售出库单</span>
                </template>
              </el-table-column>
              <el-table-column align="left" label="来源单号" min-width="180px" v-if="showField('来源单号')">
                <template slot-scope="{ row }">
                  <span>{{ row.SourceDocNo }}</span>
                </template>
              </el-table-column>
              <el-table-column align="left" label="价格策略类型" min-width="100px" v-if="showField('价格策略类型')">
                <template slot-scope="{ row }">
                  <span>{{ row.PriceStrategyId }}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" fixed="right" label="操作" v-if="!ReviewStatus">
                <template slot-scope="{ row, $index }">
                  <el-button v-if="canWrite" type="text" @click.stop="delTableList(row, $index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table></el-tab-pane
          >
          <el-tab-pane label="汇总" name="2">
            <el-table border class="table_bottom table-line tb-c-head" :data="tableDataSummary" stripe style="margin-top: 18px" show-summary :summary-method="getSummaries">
              <el-table-column label="存货名称" prop="ProductName" align="left" min-width="100">
                <template slot-scope="{ row }">
                  <span>{{ row.ProductName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="存货编码" prop="ProductNo" align="left" min-width="160">
                <template slot-scope="{ row }">
                  <span>{{ row.ProductNo }}</span>
                </template>
              </el-table-column>
              <el-table-column label="件数" prop="PackingQuantity" align="right" min-width="100">
                <template slot-scope="{ row }">
                  <span>{{ $commonJs.toThousands(row.PackingQuantity) }}</span>
                </template>
              </el-table-column>
              <el-table-column label="计量单位" prop="UnitName" align="left" min-width="100">
                <template slot-scope="{ row }">
                  <span>{{ row.UnitName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="数量" prop="Quantity" align="right" min-width="100">
                <template slot-scope="{ row }">
                  <span>{{ $commonJs.toThousands(row.Quantity) }}</span>
                </template>
              </el-table-column>
              <el-table-column align="left" prop="UnitName2" label="计量单位2" min-width="120px">
                <template slot-scope="{ row }">
                  <span v-if="row.UnitType == 0"></span>
                  <span v-else>{{ row.UnitName2 }}</span>
                </template>
              </el-table-column>
              <el-table-column align="right" label="数量2" prop="Quantity2" min-width="120px">
                <template slot-scope="{ row }">
                  <span v-if="row.UnitType == 0"></span>
                  <span v-else>{{ $commonJs.toThousands(row.Quantity2) }}</span>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane></el-tabs
        >
      </el-row>
      <!-- 表体-底部 -->
      <el-row>
        <el-form-item label="审核人:" label-width="80px" style="width: 190px">
          {{ data.ReviewEmpName }}
        </el-form-item>
        <el-form-item label="审核时间:" label-width="80px" style="width: 190px">
          {{ $commonJs.toDateString(data.ReviewDate) }}
        </el-form-item>
        <el-form-item label="变更人:" label-width="80px" style="width: 190px">
          {{ data.UpdateEmpName }}
        </el-form-item>
        <el-form-item label="变更日期:" label-width="80px" style="width: 190px">
          {{ $commonJs.toDateString(data.UpdateDate) }}
        </el-form-item>
      </el-row>
    </el-form>
    <emp-dialog ref="empDialog" in-dialog selectable @select="setEmp" />
    <order-dialog ref="orderDialog" in-dialog />
    <sale-order-select ref="saleOrderSelect" in-dialog selectable multiple @select-multiple="setOrderList($event, '销售订单')" />
    <delivery-release-select ref="deliveryReleaseSelect" in-dialog selectable multiple @select-multiple="setOrderList($event, '发货通知单')" />
    <sellout-warehouse-select ref="selloutWarehouseSelect" in-dialog selectable multiple @select-multiple="setOrderList($event, '销售出库单')" />
    <print-dialog ref="printDialog" :columns="columns" :data="columnData" :form-data="formData"></print-dialog>
    <tradeunit-dialog ref="tradeunitDialog" in-dialog selectable @select="setTradeunit" />
    <order-dialog-list ref="getOrderDialog" @save="initerPrice" in-dialog />
    <amount-dialog ref="editDialog" @data="setPayData" @close-saved="reload" />
    <field-dialog ref="fieldDialog" @close-saved="setTbField" />
  </div>
</template>
<script>
// import hotkeys from 'hotkeys-js';
import VueBarcode from 'vue-barcode'
import curdMixins from '@/mixins/trend/curd'
import empDialog from '@/components/personnel/result/record/listDialog'
import orderDialog from '@/components/business/sales/saleorder/listDialog'
import printDialog from '@/components/common/printDialog/printDialog'
import accountSelect from '@/components/business/sales/select'
import saleOrderSelect from '@/components/business/sales/saleorder/listDeliveryDialog'
import deliveryReleaseSelect from '@/components/business/sales/deliveryrelease/info/listDialog'
import selloutWarehouseSelect from '@/components/business/stock/selloutwarehouse/listDialog'
// import list from "@/components/business/purchase/inquiry/list";

import saleList from '@/data/business/sales/sale/edit/list.json'
import optionMixins from '@/mixins/option'
import amountDialog from '@/components/business/sales/sale/editDialog'
import settle from '@/components/basedata/finance/settle/select'
import invoiceSelect from '@/components/basedata/finance/invoice/select'
import wmsSelect from '@/components/basedata/basedoc/wms/select'
import businessSelect from '@/components/basedata/basedoc/business/select'
import tradeunitDialog from '@/components/basedata/business/come/listDialog'
import orderDialogList from '@/components/business/sales/sale/priceDialog'

import fieldDialog from '@/components/common/fieldDialog'
export default {
  name: 'editSale',
  mixins: [curdMixins, optionMixins],
  components: {
    // list,
    empDialog,
    orderDialogList,
    accountSelect,
    VueBarcode,
    printDialog,
    saleOrderSelect,
    deliveryReleaseSelect,
    selloutWarehouseSelect,
    settle,
    invoiceSelect,
    wmsSelect,
    businessSelect,
    tradeunitDialog,
    amountDialog,
    orderDialog,
    fieldDialog
  },
  data() {
    return {
      api: require('@/api/sa/saDoc').default,
      productApi: require('@/api/sa/quotation').default,
      sourceTypeApi: require('@/api/ba/sourceType').default,
      getApiQuantity: require('@/api/stock/stSpillLossDoc').default,
      pdApi: require('@/api/ba/product').default,
      tradeUnitApi: require('@/api/ba/tradeUnit').default,
      transportApi: require('@/api/ba/transport').default,
      code_api: require('@/api/sy/serialCode').default,
      businessTypeApi: require('@/api/ba/businessType').default,
      docSetting_api: require('@/api/sy/docSetting').default,
      warehouseApi: require('@/api/ba/warehouse').default,
      warehousePositionApi: require('@/api/ba/warehousePosition').default,
      packingspeciApi: require('@/api/ba/packingspeci').default,
      propertyApi: require('@/api/ba/property').default,
      propertyList: [],
      colorApi: require('@/api/ba/color').default,
      initDAccount: [],
      deleteDateList: [],
      initTotal: 0,
      tableColorShow: true,
      formData: [],
      columnkey: [],
      isSelect: false, // 是否有选单的操作
      columns: [],
      columnData: [],
      colorList: [],
      DAccount: [],
      tableColorShow: true,
      listTotal: 0,
      pageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1
      },
      data: {
        DocId: 0,
        DocNo: '',
        DocDate: this.$commonJs.getToday(),
        DocType: 0,
        BusinessTypeId: null,
        BusinessType: '',
        TradeUnitId: null,
        Person: '',
        Phone: '',
        Address: '',
        DeliveryDate: '',
        SettleId: null,
        ExpiringDate: '',
        WarehouseId: null,
        Remark: '',
        WarehousePositionId: null,
        WarehousePositionName: null,
        WarehousePositionList: [],
        EmpId: 0,
        DpId: 0,
        InvoiceTypeId: null,
        InvoiceNo: '',
        InvoiceAmount: 0,
        Amount: 0,
        TaxAmount: 0,
        TaxLimit: 0,
        ReceiptAmount: 0,
        ShowTax: 0,
        DisposeTax: 0,
        Receipts: [],
        Status: 0,
        OutStatus: 0,
        ReceiptStatus: 0,
        CompleteStatus: 0,
        ExecStatus: 0,
        CompletionDate: '',
        MakeEmpId: 0,

        ReviewEmpId: 0,
        ReviewDate: '',
        UpdateEmpId: 0,
        UpdateDate: '',
        SettleName: '',
        WarehouseName: '',
        TradeUnitNo: '',
        TradeUnitType: 0,
        ShortName: '',
        FullName: '',
        EmpName: '',
        DpName: '',
        DpNo: '',
        InvoiceTypeName: '',
        MakeEmpName: '',
        ReviewEmpName: '',
        UpdateEmpName: '',
        Products: []
      },
      tableDataSummary: [
        {
          ProductNo: '',
          ProductName: '',
          UnitType: 0,
          UnitName: '',
          Quantity: null,
          Price: null,
          Amount: null,
          UnitName2: '',
          Price2: null,
          Quantity2: null,
          PackingQuantity: null
        }
      ],
      activeName: '1',
      isMainUnitId2: false,
      Mode: 0,
      isSave: false,
      tabPosition: '',
      reach: '联查',
      businessTypeList: [],
      handledBy: '',
      preparedBy: '',
      IsGift: false,
      service: null,
      is_orderUpdateStatus: false,
      productList: [],
      tradeUnitList: [],
      transportList: [],
      tableList: [],
      optionList: [],
      isClickSave: false,
      rules: {
        DocDate: [{ required: true, message: '单据日期不能为空', trigger: 'blur' }],
        DocNo: [{ required: true, message: '单据编码不能为空', trigger: 'blur' }],
        TradeUnitId: [{ required: true, message: '客户不能为空', trigger: 'change' }],
        WarehouseId: [{ required: true, message: '仓库不能为空', trigger: 'change' }],
        BusinessTypeId: [{ required: true, message: '业务类型不能为空', trigger: 'blur' }],
        Address: [{ required: true, message: '送货地址不能为空', trigger: 'blur' }],
        TransportId: [{ required: true, message: '运输方式不能为空', trigger: 'blur' }],
        ReceiptAmount: [{ required: true, message: '现结金额不能为空', trigger: 'blur' }],
        EmpId: [{ required: true, message: '经手人不能为空', trigger: 'blur' }],
        Remark: [{ required: true, message: '备注不能为空', trigger: 'blur' }]
      },
      option: {
        // 换算率
        Iinvexchrate: 0,
        //数量
        Quantity: 0,
        //数量舍零
        IsQuantityRounding: true,
        // 单价整数
        UnitPrice: 0,
        // 单价小数
        UnitPriceDecimals: 0,
        // 单价舍零
        IsUnitPriceRounding: true
      },
      detailFields: [],
      showDetail: false,
      isLoading: true,
      isEdit: false,
      warehouseList: [],
      Head: [
        { Value: 'BatchNumber', Name: '批号', Width: '180' },
        { Value: 'WarehouseName', Name: '仓库', Width: '100' },
        { Value: 'ColorName', Name: '颜色', Width: '80' },
        { Value: 'PropertyName', Name: '属性', Width: '80' },
        // { Value: 'BatchStartDate', Name: '批次起始日期', Width: '100' },
        // { Value: 'ExpireDate', Name: '有效期至', Width: '100' },
        { Value: 'BaseUnitName', Name: '主单位', Width: '80' },
        { Value: 'BaseQuantity', Name: '现存量', Width: '80' }
      ],
      batchListTotal: 0,
      batchPageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1
      },
      batchList: [],
      packingspeciList: [],
      PropertyAccount: [],
      initPropertyAccount: [],
      initPropertyTotal: 0,
      listPropertyTotal: 0,
      pagePropertyParams: {
        pageSize: 7, //分页大小
        pageIndex: 1
      },
      PropertyHead: [
        { Value: 'PropertyNo', Name: '属性编码', Width: '150' },
        { Value: 'PropertyName', Name: '属性名称', Width: '150' }
      ]
    }
  },
  computed: {
    tableAmountSum() {
      let sum = 0
      let length = this.tableList.length
      for (let i = 0; i < length; ++i) {
        sum = sum + parseFloat(this.tableList[i]?.Amount ?? 0)
      }
      sum = sum.toFixed(2)
      sum = this.$commonJs.toThousands(sum)
      return sum
    },
    orderUpdateStatus() {
      return this.data.Status == 2 && !this.is_orderUpdateStatus ? true : false
    },
    canPrice() {
      return this.$permission.canPrice('/business/sales/sale')
    },
    canWrite() {
      return this.$permission.canWrite('/business/sales/sale')
    },
    canReview() {
      return this.$permission.canReview('/business/sales/sale')
    },
    ReviewName() {
      return this.data.Status == 2 ? '弃审' : '审核'
    },
    isLineAbort() {
      return this.data.DocId > 0 && this.data.Products.length > 0 ? false : true
    },
    ReviewStatus() {
      return this.data.Status == 2 ? true : false
    }
  },
  watch: {
    data: {
      deep: true,
      handler() {
        if (this.isLoading) return
        console.log('watch-data--------------------')
        this.isEdit = true
        if (this.$route.meta.data) {
          this.$route.meta.data.isEdit = true
        }
      }
    },
    tableList: {
      deep: true,
      handler() {
        if (this.isLoading) return
        console.log('watch-tableList--------------------')
        this.isEdit = true
        if (this.$route.meta.data) {
          this.$route.meta.data.isEdit = true
        }
      }
    }
  },
  mounted() {
    this.init()
    this.isClickSave = false
    // this.api.list({}).then((res) => (this.productList = res.Data));
    if (this.$route.params.isSave) this.isSave = true
    if (this.$route.params.mode == 'create' || !this.$route.params.mode) {
      this.createOrder()
    }

    // console.log("触发编辑");
    if (this.$route.params.mode == 'edit') {
      this.editOrder(this.$route.params.data.DocId)
    }
    if (this.$route.params.mode == 'details') {
      this.editOrder(this.$route.params.data.DocId)
    }

    // /** 快捷键 */
    // var that = this
    // var w = window
    // //保存
    // hotkeys('alt+s', function(e){
    //   that.save()
    // });
    // // 保存后新增 bug：保存失败后不能新增
    // hotkeys('alt+t', function(e){
    //   that.save()
    //   setTimeout(() => {
    //     that.$message.success("新增");
    //     Object.assign(that.$data, that.$options.data.call(that));
    //     that.init();
    //     that.createOrder();
    //     setTimeout(() => {
    //       that.$refs.ruleForm.clearValidate();
    //     }, 30);
    //   }, 1500);
    // });
    // //打印
    // hotkeys('alt+d', function(e){
    //   that.save()
    //   setTimeout(() => {
    //     var url = location.origin + "/#/customprintview/销货单/" + that.data.DocId;
    //     w.open(url, "_blank");
    //   }, 1500);
    // });
  },
  methods: {
    handleClick(tab, event) {
      if (this.activeName == '2') {
        this.tableDataSummary = this.summarizeTableData()
        console.log(this.tableDataSummary)
      }
    },
    summarizeTableData() {
      const summary = {}
      // 遍历所有产品，进行汇总
      console.log('this.tableList', this.tableList)
      this.tableList.forEach(product => {
        if (product.ProductNo) {
          if (!summary[product.ProductNo]) {
            // 如果是第一次遇到该产品，则初始化
            summary[product.ProductNo] = {
              ProductNo: product.ProductNo,
              ProductName: product.ProductName,
              UnitType: product.UnitType,
              UnitName: product.SaUnitName,
              UnitName2: product.UnitName2,
              Quantity: product.SaQuantity,
              Quantity2: product.UnitType == 1 ? product.Quantity2 : 0,
              PackingQuantity: product.PackingQuantity,
              count: 1
            }
          } else {
            // 否则，累加数量和总价，并增加计数
            if (product.UnitType == 1 && summary[product.ProductNo].UnitName != product.UnitName) {
              summary[product.ProductNo].Quantity += product.SaQuantity
              summary[product.ProductNo].Quantity2 += product.Quantity2
            } else {
              summary[product.ProductNo].Quantity += product.SaQuantity
              if (product.UnitType == 1) summary[product.ProductNo].Quantity2 += product.Quantity2
            }
            summary[product.ProductNo].PackingQuantity += product.PackingQuantity
            summary[product.ProductNo].count++
          }
        }
      })

      // 将汇总结果转换为数组，并计算平均单价
      return Object.values(summary).map(sum => ({
        ProductNo: sum.ProductNo,
        ProductName: sum.ProductName,
        UnitType: sum.UnitType,
        UnitName: sum.UnitName,
        UnitName2: sum.UnitName2,
        Quantity: sum.Quantity,
        Quantity2: sum.Quantity2,
        PackingQuantity: sum.PackingQuantity
      }))
    },
    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      const fieldNames = columns.map(col => col.property)
      fieldNames.forEach((field, index) => {
        if (field && ['Quantity', 'Quantity2', 'PackingQuantity'].includes(field)) {
          const values = data.map(item => Number(item[field]))
          console.log('values', values)
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + value
              } else {
                return prev
              }
            }, 0)
            //金额 固定2位小数
            const arr2 = ['Amount']
            var v = sums[index]
            if (arr2.indexOf(field.property) != -1) {
              v = v.toFixed(2)
              let vStr = v.toString().split('.')
              if (Number(vStr[1]) <= 0) v = vStr[0]
            }
            if (v > 0) {
              v = Number(v).toLocaleString()
            }
            sums[index] = v
          } else {
            sums[index] = '-'
          }
        } else {
          sums[index] = ''
        }
      })
      sums[0] = '合计'
      return sums
    },
    onPropertySelect(val, row, index) {
      console.log(val, row, 'onPropertySelect')
      if (val) {
        row.PropertyId = val.PropertyId
        row.PropertyName = val.PropertyName
        row.PropertyNo = val.PropertyNo
      } else {
        row.PropertyNo = ''
      }
      this.$nextTick(() => {
        if (row.ProductId > 0) {
          var BarCode = row.ProductNo + '*' + (row.ColorNo || 0) + '*' + (row.PropertyNo || 0)
          row.BarCode = BarCode
          console.log(row.BarCode, 'onPropertySelect')
          //(this.tableList, index, row)
          this.$set(row, 'BarCode', BarCode)
          this.tableList.splice(index, 1, row)
          this.$forceUpdate()
        }
      })
    },
    resetPropertyFun(row) {
      this.pagePropertyParams.pageIndex = 1
      this.PropertyAccount = this.initPropertyAccount
      this.listPropertyTotal = this.initPropertyTotal

      let param = { pageIndex: 1, pageSize: 7, Status: 1 }

      this.propertyApi.list(param).then(res => {
        if (res.Code == 0) {
          this.PropertyAccount = res.Data
          this.listPropertyTotal = res.Count
        }
      })
    },
    currentPropertyPage({ val, text1 }, row) {
      console.log(val, text1, row)
      this.pagePropertyParams.pageIndex = val

      let param = { pageIndex: val, pageSize: 7, Status: 1, PropertyName: text1 }

      this.propertyApi.list(param).then(res => {
        if (res.Code == 0) {
          this.PropertyAccount = res.Data
          this.listPropertyTotal = res.Count
        }
      })
    },
    inputPropertyText(text) {
      this.propertyApi
        .list({
          PageIndex: 1,
          PageSize: 7,
          PropertyName: text,
          Status: 1
        })
        .then(res => {
          if (res.Code == 0) {
            this.PropertyAccount = res.Data
            this.listPropertyTotal = res.Count
          }
        })
    },
    changePackingQuantity(val, row, index) {
      if (row.PackingNumber > 0) {
        if (val) {
          row.SaQuantity = parseInt(val * row.PackingNumber)
          if (row.HasGrammage == true) {
            row.Quantity2 = row.SaQuantity * row.Rate
          }
        }
      }
    },
    changeSpeci(val, row) {
      let item = this.packingspeciList.filter(item => {
        return item.PackingSpeciId === val
      })[0]
      console.log(item, 'changeSpeci')
      if (item) {
        row.PackingNumber = item.PackingNumber
        row.RealPackingNumber = item.PackingNumber
        if (row.SaQuantity) {
          row.PackingQuantity = parseInt(row.SaQuantity / row.PackingNumber)
        }
      }
    },
    changeWarehouse(val, row, index) {
      if (row.T !== 0) {
        row.T = 1
      }

      let item = this.warehouseList.filter(item => {
        return item.value === val
      })[0]

      row.WarehouseName = item.label
      row.WarehouseId = item.value
      if (!this.data.WarehouseId) {
        this.data.WarehouseName = item.label
        this.data.WarehouseId = item.value
      }

      if (!row.ProductId) return
      let param = {
        WarehouseId: row.WarehouseId,
        Property: '销售',
        pageIndex: 1,
        pageSize: 7,
        Status: 1
      }
      let productId = row.ProductId
      let colorId = row.ColorId
      if (colorId) {
        Object.assign(param, { ColorId: colorId })
      }
      if (productId) {
        Object.assign(param, { ProductId: productId })
      }

      this.pdApi.list(param).then(res => {
        this.tableList[index].StockQuantity = res.Data[0].StockQuantity
        console.log(res.Data[0].StockQuantity)
      })
    },
    // 顶部切换仓库
    changeDataWarehouse(val) {
      let item = this.warehouseList.filter(item => {
        return item.value === val
      })[0]
      for (let i = 0; i < this.tableList.length; i++) {
        if (this.tableList[i].T !== 0) {
          this.tableList[i].T = 1
        }
        this.tableList[i].WarehouseId = item.value
        this.tableList[i].WarehouseName = item.label

        // 获取每一个仓库id this.tableList[i].WarehouseId
        // 获取每一个存货id this.tableList[i].ProductId
        let param = {
          WarehouseId: this.data.WarehouseId,
          id: this.tableList[i].ProductId,
          Property: '销售',
          pageIndex: 1,
          pageSize: 7,
          Status: 1
        }

        let colorId = this.tableList[i].ColorId

        this.pdApi.list(colorId ? { ...param, ColorId: colorId } : param).then(res => {
          this.DAccount = res.Data
          this.initDAccount = res.Data
          this.listTotal = res.Count
          this.initTotal = res.Count
          this.tableList[i].StockQuantity = res.Data[0].StockQuantity
          console.log('res.Data.StockQuantity::', res.Data[0].StockQuantity)
        })
      }
    },
    openSetField() {
      this.$refs.fieldDialog.open().then(that => {
        that.getData({ DocType: '销货单', Url: 'business/sales/sale/edit' })
      })
    },
    setTbField(isInit = false) {
      // console.log("setTbField", isInit)
      // console.log("this.$route", this.$route)
      this.showDetail = false
      this.docSetting_api.list({ DocType: '销货单', IsShow: true }).then(res => {
        if (res.Code == 0) {
          this.detailFields = res.Data.map(x => x.FormKey)
          this.$nextTick(() => {
            this.showDetail = true
            if (isInit) {
              setTimeout(() => {
                var cacheDataStr = localStorage.getItem('business_sales_sale')
                if (cacheDataStr) {
                  this.isEdit = false
                  if (this.$route.meta.data) {
                    this.$route.meta.data.isEdit = false
                  }
                  var cacheData = JSON.parse(cacheDataStr)
                  // console.log("cacheData", cacheData)
                  this.$confirm('存在缓存的数据，是否填入？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                  })
                    .then(() => {
                      this.data = { ...cacheData.data }
                      this.tableList = [...cacheData.tableList]
                      localStorage.removeItem('business_sales_sale')
                    })
                    .catch(() => {
                      localStorage.removeItem('business_sales_sale')
                    })
                }
              }, 1000)
            }
          })
        }
      })
    },
    showField(type) {
      return this.detailFields.indexOf(type) != -1
    },
    async goJump(index) {
      let params = {}
      let ids = []
      let res = null
      switch (index) {
        case 1:
          params.SourceDocId = this.data.DocId
          res = await this.sourceTypeApi.info('销货单')
          params.SourceType = res.SourceTypeId
          this.$router.push({ name: 'saleinvoice', params: params })
          break
        case 2:
          ids = this.data.Products.filter(item => {
            return item.SourceType === 17
          }).map(item => {
            return item.SourceDocId
          })
          console.log('ids', ids)
          if (ids.length === 0) {
            //this.$message.error('单据未引用销售出库单，无法进行联查')
            params.SourceDocId = this.data.DocId
            res = await this.sourceTypeApi.info('销货单')
            params.SourceType = res.SourceTypeId
            this.$router.push({ name: 'selloutwarehouse', params: params })
            break
          } else {
            params.Ids = ids
            res = await this.sourceTypeApi.info('销售出库单')
            params.SourceType = res.SourceTypeId
            this.$router.push({ name: 'selloutwarehouse', params: params })
          }
          break
        case 3:
          params.SourceDocId = this.data.DocId
          res = await this.sourceTypeApi.info('销货单')
          params.SourceType = res.SourceTypeId
          this.$router.push({ name: 'receivables', params: params })
          break
        case 4:
          ids = this.data.Products.filter(item => {
            return item.SourceType === 6
          }).map(item => {
            return item.SourceDocId
          })
          if (ids.length === 0) {
            this.$message.error('单据未引用销售订单，无法进行联查')
          } else {
            params.Ids = ids
            res = await this.sourceTypeApi.info('销售订单')
            params.SourceType = res.SourceTypeId
            this.$router.push({ name: 'saleorder', params: params })
          }
          break
      }
    },
    BusinessChange(val) {
      this.data.BusinessTypeId = val.BusinessTypeId
      this.data.MinusEntry = val.MinusEntry
      this.data.BusinessType = val.BusinessType
      this.changeNumber(this.data.MinusEntry)
    },
    changeNumber(status) {
      // console.log("status", status)
      if (status == 1) {
        this.tableList.forEach((item, index) => {
          if (item.ProductId > 0 && item.SaQuantity != null && item.SaQuantity !== '') {
            item.SaQuantity = item.SaQuantity > 0 ? 0 - item.SaQuantity : item.SaQuantity
            item.Quantity2 = item.Quantity2 > 0 ? 0 - item.Quantity2 : item.Quantity2
            this.changeQuantity(item.SaQuantity, item, index, 0)
            //this.changeQuantity2(item.Quantity2, item, index, 0);
          }
        })
      } else if (status == 0) {
        this.tableList.forEach((item, index) => {
          if (item.ProductId > 0 && item.SaQuantity != null && item.SaQuantity !== '') {
            item.SaQuantity = Math.abs(item.SaQuantity)
            item.Quantity2 = Math.abs(item.Quantity2)
            this.changeQuantity(item.SaQuantity, item, index, 0)
            //this.changeQuantity2(item.Quantity2, item, index, 0);
          }
        })
      }
    },
    //单据保存回显
    initerPrice(price) {
      console.log(price, 'price===')
      this.currentRow.Price = price
      this.changePrice(this.currentRow, this.currentIndex)
    },
    //单价弹窗
    openSales(row, index) {
      this.currentRow = row
      this.currentIndex = index
      let ProductName = row.ProductName
      let TradeUnitName = this.data.TradeUnitName
      this.$refs.getOrderDialog.open().then(that => {
        that.setData(ProductName, TradeUnitName)
      })
    },
    //金额组件数据
    setPayData(data, deleteDateList) {
      this.data.Receipts = data
      this.deleteDateList.push(...deleteDateList)
      this.data.ReceiptAmount = data
        .map(i => i.ReceiptAmount)
        .reduce((prev, curr) => {
          const value = Number(curr)
          if (!isNaN(value)) {
            return prev + curr
          } else {
            return prev
          }
        }, 0)
      this.data = { ...this.data }
    },
    //清除金额单据
    clear() {
      let deleteDateList = this.data.Receipts.filter(item => {
        return item.T !== 0
      })
      deleteDateList.forEach(item => {
        item.T = 2
      })
      this.setPayData([], deleteDateList)
    },
    //打开金额弹窗
    openAmount() {
      if (this.isClickSave) {
        this.data.Receipts.forEach(item => {
          item.T = null
        })
      }
      this.$refs.editDialog.open().then(that => {
        that.setMinusEntry(this.data.MinusEntry)
      })
    },
    //获取默认选中第一个业务类型
    getBusinessTypeId(info) {
      this.data.BusinessTypeId = info
    },
    onInsert(e) {
      let { type, index } = e
      this.interpolate(null, index, type)
    },
    interpolate(row, index, type = '') {
      let o = {
        T: 0,
        // SnCode,
        StockQuantity: 0,
        ExistQuantity: 0,
        DocProductId: 0,
        OrderId: 0,
        SourceDocId: 0,
        SourceDtsId: 0,
        SourceType: 0,
        OrderProductId: 0,
        WarehouseId: this.data.WarehouseId,
        ProductId: 0,
        ColorId: null,
        ColorName:'',
        ColorNo:'',
        SaUnitId: 0,
        SaQuantity: 0,
        UnitId2: 0,
        Quantity2: 0,
        Rate: 0,
        QuotedPrice: 0,
        Discount: 100,
        TaxRate: 0,
        Price: 0,
        TaxPrice: 0,
        Amount: 0,
        TaxAmount: 0,
        TaxLimit: 0,
        DiscountAmount: 0,
        DeliveryDate: '',
        IsGift: false,
        CostPrice: 0,
        CostAmount: 0,
        OutQuantity: 0,
        OutQuantity2: 0,
        InvoicedQuantity: 0,
        InvoicedQuantity2: 0,
        ReturnQuantity: 0,
        SettlementAmount: 0,
        // 后端补充
        PriceStrategyId: 0,
        ReceiptAmount: 0,
        ProductNo: '',
        ProductType: 0,
        ProductName: '',
        ShortName: '',
        ProductSpec: '',
        Property: '',
        ImgUrl: '',
        WarehouseNo: '',
        WarehouseName: '',
        SaUnitName: '',
        UnitName: '',
        DocNo: '',
        OrderNo: '',
        SourceDocNo: '',
        PropertyId:null,
        PropertyName:'',
        PropertyNo:''
      }
      if (type == 'down') {
        index = index + 1
      }

      this.tableList.splice(index, 0, o)
      let copy = JSON.parse(JSON.stringify(this.tableList))
      this.tableList = []
      this.$nextTick(() => {
        this.tableList = copy
      })
    },
    getInvoiceType(value) {
      for (let i = 0; i < value.length; i++) {
        if (value[i].InvoiceTypeName == '收据') {
          this.data.InvoiceTypeName = value[i].InvoiceTypeName
          this.data.InvoiceTypeId = value[i].InvoiceTypeId
          return
        } else {
          this.data.InvoiceTypeName = value[0].InvoiceTypeName
          this.data.InvoiceTypeId = value[0].InvoiceTypeId
        }
      }
    },
    print() {
      // let newpage = this.$router.resolve({
      //   path: '/salePrint2?id=' + this.data.DocId
      // })
      // window.open(newpage.href, '_blank');
    },
    /*  onPrint2(row) {
      var url = location.origin + '/#/customprintview/销货单/' + row.DocId
      window.open(url, '_blank')
    },*/

    print(row) {
      let newpage = this.$router.resolve({
        path: '/salePrint2?id=' + row.DocId
      })
      window.open(newpage.href, '_blank')
    },
    openTradeunit() {
      if (!this.isSelect) {
        this.$refs.tradeunitDialog.open().then(that => {
          that.getData({ TradeUnitTypes: [0, 2], Status: 1 })
          // that.getData();
        })
      }
    },
    previewNo(val = this.$commonJs.getToday()) {
      this.code_api.previewNo('销货单', val).then(res => {
        // console.log("serialType", res);
        if (res.Code == 0) {
          this.Mode = res.Data.Mode
          this.data.DocNo = res.Data.PreviewNo
        } else {
          this.$message.warning('获取销货单编码失败')
        }
      })
    },
    init() {
      // console.log("this.data", this.data);
      this.callOptionApi()

      this.sourceTypeApi.list({}).then(res => {
        if (res.Code == 0) {
          this.SourceTypeIdArr = res.Data
          let params = '销货单'
          let index = this.SourceTypeIdArr.findIndex(item => item.SourceType == params)
          let SourceTypeId = this.SourceTypeIdArr[index].SourceTypeId
          this.businessTypeApi.getSourceTypeToBusinessType(SourceTypeId).then(res => {
            if (res.Code == 0) {
              this.businessTypeList = res.Data
              this.data.BusinessTypeId = this.businessTypeList[0].BusinessTypeId
              this.data.BusinessType = this.businessTypeList[0].BusinessType
              this.data.MinusEntry = this.businessTypeList[0].MinusEntry //0=普通销售(数量是正数) 1=销售退货(数量是负数)

              this.changeNumber(this.data.MinusEntry)
            }
          })
        }
      })
      this.tradeUnitApi.list({ TradeUnitTypes: [0, 2], Status: 1 }).then(res => {
        if (res.Code == 0) this.tradeUnitList = res.Data
      })
      this.transportApi.list({}).then(res => {
        if (res.Code == 0) this.transportList = res.Data
      })

      this.packingspeciApi.list({ Status: 1 }).then(res => {
        if (res.Code === 0) {
          this.packingspeciList = res.Data
        }
      })
      // this.pdApi
      //   .list({ Property: "销售", pageIndex: 1, pageSize: 7, Status: 1, })
      //   .then((res) => {
      //     this.DAccount = res.Data;
      //     this.initDAccount = res.Data;
      //     this.listTotal = res.Count;
      //     this.initTotal = res.Count;
      // });
      this.warehouseApi.list({ Status: 1, WarehouseType: 1 }).then(res => {
        if (res.Code === 0) {
          if (this.viewType === 'create') {
            this.data.WarehouseId = res.Data[0].WarehouseId
            this.data.WarehouseName = res.Data[0].WarehouseName
          }
          this.warehouseList = res.Data.map(item => {
            return {
              key: item.WarehouseId,
              label: item.WarehouseName,
              value: item.WarehouseId
            }
          })
        }
      })
      this.colorApi.list({ Status: 1 }).then(res => {
        if (res.Code == 0) {
          this.colorList = res.Data
        }
      })
      this.propertyApi.list({ Status: 1 }).then(res => {
        if (res.Code == 0) {
          this.propertyList = res.Data
        }
      })
      this.setTbField(true)
    },
    createOrder() {
      const user = this.$store.state.user
      if (user) {
        this.data.EmpId = user.empId
        this.data.EmpName = user.name
        this.data.MakeEmpId = user.id
        this.data.MakeEmpName = user.name
      }
      this.addList()
      this.previewNo()
    },
    RateChange(data, row, index) {
      if (data < 0 || data == '') return
      if (row.T === 3) row.T = 1
      this.changeQuantity(this.tableList[index].SaQuantity, row, index)
    },
    editOrder(data, type = 0) {
      this.isLoading = true
      console.log('执行编辑type=' + type, data)
      this.api.info(data).then(res => {
        if (res.Code === 0) {
          this.isSave = true
          this.data = {
            ...res.Data,
            InvoiceTypeId: res.Data.InvoiceTypeId || null,
            WarehouseId: res.Data.WarehouseId || null,
            SettleId: res.Data.SettleId || null
          }
          this.data.Receipts.forEach(item => (item.T = null))
          console.log('Receipts', this.data.Receipts)
          // this.tableList = res.Data.Products?.map((item) => ((item.T = 3), item));
          this.tableList = res.Data.Products?.map(item => {
            console.log(item, 'product')
            item.IsBatchNumber = item.BatchNumber ? true : false
            item.T = 3
            item.WarehousePositionList = [{ WarehousePositionId: item.WarehousePositionId, WarehousePositionName: item.WarehousePositionName }]
            item.UnitName2 = item.UnitName
            return item
          })
          this.tableList.forEach((item, i) => {
            if (item.Units.length > 0 && item.SaUnitId && item.UnitId2) {
              const findIndex = item.Units.findIndex(el => el.UnitId == item.SaUnitId)
              const IsMainIndex = item.Units.findIndex(el => el.IsMain == true) //主单位的索引
              const noMainIndex = item.Units.findIndex(e => e.IsMain == false) //不是主单位的索引
              if (findIndex == IsMainIndex) {
                //判断当前销售单位是否为主单位
                item.Rate = item.Units[noMainIndex].Rate
                item.ChangeType = item.Units[noMainIndex].ChangeType
                item.IsMain = true
              } else {
                //如果当前是赋单位
                item.Rate = item.Units[noMainIndex].Rate
                item.ChangeType = item.Units[noMainIndex].ChangeType
                item.IsMain = false
              }

              this.changeQuantity(item.SaQuantity, item, i)
            } else {
              item.Units.forEach(v => {
                if (v.ChangeType == 1) item.ChangeType = v.ChangeType
              })
            }
          })
        }

        setTimeout(() => {
          //根据普通销售/销售退货 类型进行判断 数量是正数还是负数
          var businessType = this.businessTypeList.filter(x => {
            return x.BusinessTypeId == res.Data.BusinessTypeId
          })[0]
          if (!businessType) {
            this.businessTypeApi.info(res.Data.BusinessTypeId).then(res => {
              businessType = res.Data
              this.data.BusinessType = businessType.BusinessType
              this.data.BusinessTypeId = businessType.BusinessTypeId
              this.data.MinusEntry = businessType.MinusEntry
            })
          } else {
            this.data.BusinessType = businessType.BusinessType
            this.data.BusinessTypeId = businessType.BusinessTypeId
            this.data.MinusEntry = businessType.MinusEntry
          }
          if (this.data.MinusEntry == 1) {
            this.tableList.forEach((item, index) => {
              item.SaQuantity = item.SaQuantity > 0 ? 0 - item.SaQuantity : item.SaQuantity
              item.Quantity2 = item.Quantity2 > 0 ? 0 - item.Quantity2 : item.Quantity2
              item.Amount = item.Amount > 0 ? 0 - item.Amount : item.Amount
            })
          } else if (this.data.MinusEntry == 0) {
            this.tableList.forEach((item, index) => {
              item.SaQuantity = Math.abs(item.SaQuantity)
              item.Quantity2 = Math.abs(item.Quantity2)
              item.Amount = Math.abs(item.Amount)
            })
          }
        }, 500)
        console.log('Products', this.data.Products.length)
        this.data.Products.forEach((item, index) => {
          let param = { ProductId: item.ProductId }
          let TradeUnitId = this.data.TradeUnitId
          //TradeUnitId ? param[TradeUnitId]=TradeUnitId : param
          this.api.minimumPrice(TradeUnitId ? { ...param, TradeUnitId: this.data.TradeUnitId } : param).then(res => {
            if (res.Data) {
              this.tableList[index].RetailPrice = res.Data.Price
            } else {
              this.$message.warning(res.msg)
            }
          })
        })
        if (type === 1) {
          console.log('review')
          // this.Review()
        }
        if (res.Data.Products.length == 0) this.addList()
        setTimeout(() => {
          this.isLoading = false
          // console.log("this.$route", this.$route)
          //   var cacheDataStr = localStorage.getItem("business_sales_sale");
          //   if (cacheDataStr) {
          //     this.isEdit = false;
          //     if (this.$route.meta.data) {
          //       this.$route.meta.data.isEdit = false;
          //     }
          //     var cacheData = JSON.parse(cacheDataStr);
          //     this.$confirm("存在缓存的数据，是否填入？", "提示", {
          //       confirmButtonText: "确定",
          //       cancelButtonText: "取消",
          //     })
          //       .then(() => {
          //         this.data = { ...cacheData.data };
          //         this.tableList = [...cacheData.tableList];
          //         localStorage.removeItem("business_sales_sale");
          //       })
          //       .catch(() => {
          //         localStorage.removeItem("business_sales_sale");
          //       });
          //   }
        }, 1000)
      })
    },
    toggleOrder() {
      this.$refs.saleQuotationSelect.open()
    },

    onChangeWarehousePosition(e, row, id) {
      if (e) {
        const o = { Status: 1, WarehouseId: id }
        this.warehousePositionApi.list(o).then(res => {
          let list = res.Data.map(item => {
            return {
              WarehousePositionId: item.WarehousePositionId,
              WarehousePositionName: item.WarehousePositionName
            }
          })
          this.$nextTick(() => {
            this.$delete(row, 'WarehousePositionList')
            this.$set(row, 'WarehousePositionList', list)
          })
        })
      }
    },
    // 获取进货单明细
    async setOrderList(data, type) {
      //DeliveryDate
      console.log(data, 'data')
      let Quantity = this.tableList.map(i => i.ProductId)
      let SourceType = null
      let addList = []
      if (data.TradeUnitId > 0) {
        this.data.FullName = data.FullName
        this.data.TradeUnitId = data.TradeUnitId
      }
      if (type === '销售订单') {
        const res = await this.sourceTypeApi.info('销售订单')
        let SourceType = res.SourceTypeId
        addList = data.List.reduce((arr, item) => {
          if (!Quantity.includes(item.ProductId)) {
            let UnitType = 0
            if (item.Units.length != 0) {
              UnitType = 1
            }
            item.PackInfos.forEach(x => {
              arr.push({
                DocProductId: 0,
                Requirement: '',
                ...item,
                QuotedPrice: item.QuotedPrice || 0,
                Discount: item.Discount || 100,
                TaxRate: item.TaxRate || 0,
                Price: item.Price || 0,

                TaxPrice: item.TaxPrice || 0,
                Amount: item.Amount || 0,
                TaxLimit: item.TaxLimit || 0,
                TaxAmount: item.TaxAmount || 0,
                DiscountAmount: 0,
                Units: item.Units,
                SourceType,
                // SourceDtsId:item.
                SourceDocId: item.OrderId,
                SourceDtsId: item.OrderProductId,
                SourceDocNo: item.OrderNo,
                UnitType: UnitType,
                isOrderData: true,
                UnitId2: item.UnitId2,
                Grammage: item.Grammage,
                HasGrammage: item.HasGrammage,
                Units: item.Units,
                IsBatchNumber: item.BatchNumber ? true : false,
                BatchNumber: item.BatchNumber,
                PackingQuantity: x.PackingQuantity,
                PackingNumber: x.PackingNumber,
                RealPackingNumber: x.RealPackingNumber,
                SaQuantity: x.RealQuantity,
                Quantity2: x.RealQuantity2,
                PackingSpeciId: x.PackingSpeciId,
                PropertyId: x.PropertyId,
                ColorId: x.ColorId,
                BarCode: x.BarCode,
                SpeciName: x.SpeciName
              })
            })
          } else {
            this.$message.warning('已有相同订单')
          }
          return arr
        }, [])
      }
      if (type === '发货通知单') {
        console.log(data, 'datagogog')
        const res = await this.sourceTypeApi.info('发货通知单')
        let SourceType = res.SourceTypeId
        addList = data.List.reduce((arr, item) => {
          if (!Quantity.includes(item.ProductId)) {
            let UnitType = 0
            if (item.Units.length != 0) {
              UnitType = 1
            }
            arr.push({
              OrderProductId: item.OrderProductId,
              OrderId: item.OrderId,
              Requirement: '',
              ...item,
              SourceType,
              //Units
              // SourceDtsId:item.
              SaQuantity: item.RealQuantity,
              Quantity2: item.RealQuantity2,
              SourceDocId: item.DeliveryDocId,
              SourceDtsId: item.DeliveryDocProductId,
              // SourceDocId: item.OrderProductId,
              SourceDocNo: data.Order,
              QuotedPrice: 0,
              Discount: 100,
              TaxRate: 0,
              Price: 0,

              TaxPrice: 0,
              Amount: 0,
              TaxLimit: 0,
              TaxAmount: 0,
              DiscountAmount: 0,
              UnitType: UnitType,
              isOrderData: true,
              UnitId2: item.UnitId2,
              Grammage: item.Grammage,
              HasGrammage: item.HasGrammage,
              Units: item.Units,
              IsBatchNumber: item.BatchNumber ? true : false,
              BatchNumber: item.BatchNumber,
              BarCode: item.BarCode ?? ''
            })
          } else {
            this.$message.warning('已有相同订单')
          }
          return arr
        }, [])

        console.log('addList', addList)
        // addList?.forEach((item, i) => {
        //   item.UnitType = 0;
        //   item.ChangeType = 0;
        //   item.UnitId = item.SaUnitId;
        //   if (item.Units.length === 0) {
        //     // row.UnitId2 = e.SaUnitId;
        //     // row.SaUnitName = e.SaUnitName;
        //     // row.UnitName = e.SaUnitName;
        //     // row.Rate = 1;
        //     item.UnitId = item.SaUnitId;
        //     item.Rate = 0;
        //     item.Quantity2 = 0;
        //   } else {
        //     item.UnitType = 1;
        //     let index = this.getUnitIndex(3, item.Units, item.UnitId);
        //     let data = this.getUnitValue(item.Units, index);
        //     let assistIndex = 0;
        //     let assistData = {};
        //     item.IsMain = data.IsMain;
        //     item.Units.forEach((v) => {
        //       if (v.ChangeType == 1) item.ChangeType = v.ChangeType;
        //     });

        //     if (data.IsMain) {
        //       assistIndex = this.getUnitIndex(2, item.Units);
        //       assistData = this.getUnitValue(item.Units, assistIndex);
        //       item.Rate = assistData.Rate.toFixed(5);
        //     } else {
        //       assistIndex = this.getUnitIndex(1, item.Units);
        //       assistData = this.getUnitValue(item.Units, assistIndex);
        //       item.Rate = data.Rate.toFixed(5);
        //     }
        //     item.UnitId2 = assistData.UnitId;
        //     item.UnitName2 = assistData.UnitName;
        //   }
        //   this.changeQuantity(item.SaQuantity, item, i);
        // });
      }
      if (type === '销售出库单') {
        const res = await this.sourceTypeApi.info('销售出库单')
        let SourceType = res.SourceTypeId
        if (data.List && data.List.length) {
          this.data.WarehouseName = data.List[0].WarehouseName
          this.data.WarehouseId = data.List[0].WarehouseId
          if (data.List[0].TradeUnitId) {
            this.data.TradeUnitId = data.List[0].TradeUnitId
            this.data.TradeUnitName = data.List[0].TradeUnitName
            this.isSelect = true
          }
        }
        addList = data.List.reduce((arr, item) => {
          if (!Quantity.includes(item.ProductId)) {
            let UnitType = 0
            if (item.Units.length != 0) {
              UnitType = 1
            }
            // if (item.DocId) item.DocId = 0;
            // if (item.DocProductId) item.DocProductId = 0;

            arr.push({
              Requirement: '',
              ...item,

              SourceType,
              // SourceDtsId:item.
              SourceDocId: item.DocId,
              SourceDtsId: item.DocProductId,
              SourceDocNo: data.Order,
              OrderId: 0,
              DocId: 0,
              DocProductId: 0,
              SaQuantity: item.Quantity,
              SaUnitId: item.UnitId,
              SaUnitName: item.UnitName,
              UnitId2: item.UnitId2,
              UnitName2: item.UnitName2,
              Price2: item.Price2,
              QuotedPrice: item.QuotedPrice || 0,
              Discount: item.Discount || 100,
              TaxRate: item.TaxRate || 0,
              Price: item.Price || 0,
              TaxPrice: item.TaxPrice || 0,
              Amount: item.Amount || 0,
              TaxLimit: item.TaxLimit || 0,
              TaxAmount: item.TaxAmount || 0,
              DiscountAmount: 0,
              UnitType: UnitType,
              isOrderData: true,
              UnitId2: item.UnitId2,
              Grammage: item.Grammage,
              HasGrammage: item.HasGrammage,
              Units: item.Units,
              IsBatchNumber: item.BatchNumber ? true : false,
              BatchNumber: item.BatchNumber,
              BarCode: item.Barcode
            })
          } else {
            this.$message.warning('已有相同订单')
          }
          return arr
        }, [])
      }
      console.log(addList, 'addList')

      addList.forEach((item, i) => {
        item.ChangeType = 0
        // item.Units.forEach(v=>{
        //   if(v.ChangeType==1)item.ChangeType=v.ChangeType
        // })
        if (item.Units.length > 0 && item.SaUnitId) {
          const findIndex = item.Units.findIndex(el => el.UnitId == item.SaUnitId)
          const IsMainIndex = item.Units.findIndex(el => el.IsMain == true) //主单位的索引
          const UnitId2Index = item.Units.findIndex(el => el.UnitId == item.UnitId2) //不是主单位的索引
          const noMainIndex = item.Units.findIndex(el => el.IsMain == false)
          console.log(findIndex, IsMainIndex, item.Units, item, 'findIndex')
          if (findIndex == IsMainIndex) {
            //判断当前销售单位是否为主单位
            item.Rate = item.Units[UnitId2Index != -1 ? UnitId2Index : noMainIndex].Rate || 0
            item.ChangeType = item.Units[UnitId2Index != -1 ? UnitId2Index : noMainIndex].ChangeType || 0
            item.IsMain = true
          } else {
            //如果当前是赋单位
            item.Rate = item.Units[findIndex].Rate
            item.ChangeType = item.Units[findIndex].ChangeType
            item.IsMain = false
          }
        } else {
          item.Units.forEach(v => {
            if (v.ChangeType == 1) item.ChangeType = v.ChangeType
          })
        }
      })
      this.tableList.unshift(...addList)
      if (this.data.TradeUnitId) {
        this.isSelect = true
      }
      this.$nextTick(() => {
        this.tableList.forEach((e, i) => {
          if (!e.ProductId) {
            e.TaxPrice = 0
            e.Amount = 0
            e.TaxLimit = 0
            e.TaxAmount = 0
            e.DiscountAmount = 0

            this.changeQuantity(e.SaQuantity, e, i)
          }
        })
      })
      // console.log('data',data);
      // console.log('addList',addList);
      // console.log("Quantity", this.tableList);
    },

    resetFun(row) {
      this.pageParams.pageIndex = 1
      this.DAccount = this.initDAccount
      this.listTotal = this.initTotal

      let param = { WarehouseId: row.WarehouseId, Property: '销售', pageIndex: 1, pageSize: 7, Status: 1 }
      let colorId = row.ColorId

      this.pdApi.list(colorId ? { ...param, ColorId: colorId } : param).then(res => {
        if (res.Code == 0) {
          this.DAccount = res.Data
          this.listTotal = res.Count
        }
      })
    },
    currentPage({ val, text1 }, row) {
      console.log(val, text1, row)
      this.pageParams.pageIndex = val

      let param = { WarehouseId: row.WarehouseId, Property: '销售', pageIndex: val, pageSize: 7, Status: 1, ProductName: text1 }
      let colorId = row.ColorId

      this.pdApi.list(colorId ? { ...param, ColorId: colorId } : param).then(res => {
        if (res.Code == 0) {
          this.DAccount = res.Data
          this.listTotal = res.Count
        }
      })
    },
    inputText(text) {
      this.pdApi
        .list({
          Property: '销售',
          pageIndex: 1,
          pageSize: 7,
          ProductName: text,
          Status: 1
        })
        .then(res => {
          if (res.Code == 0) {
            this.DAccount = res.Data
            this.listTotal = res.Count
          }
        })
    },
    setProduct(row, index) {
      let data = this.productList.filter(item => item.ProductId === row.ProductId)
      this.tableList[index].ProductName = data[0].ProductName
      this.tableList[index].ProductNo = data[0].ProductNo
      this.tableList[index].ProductSpec = data[0].ProductSpec
      this.tableList[index].SaUnitName = data[0].SaUnitName
    },
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex
    },
    // 选择存货名称
    onSelect(e, row, index) {
      // if (this.data.TradeUnitId === null)
      //   return this.$message.warning("请先选择客户");
      // if (this.data.WarehouseId == null)
      //   return this.$message.warning("请先选择仓库");
      if (row.T === 3 && row.ProductId !== e.ProductId) row.T = 1
      if (row.isOrderData && row.ProductId != e.ProductId) {
        // this.data.TradeUnitId = '';
        // this.data.FullName = '';
        // this.isSelect = false;
        // this.$nextTick(() => {
        //   this.$refs.ruleForm.clearValidate();
        // })
        row.SourceType = 0
        row.SourceDocId = 0
        row.SourceDtsId = 0
        row.SourceDocNo = ''
        row.isOrderData = false
      }
      let findIndex = ''
      row.BatchNumber = null
      row.IsBatchNumber = e.BatchNumber ?? false
      row.BatchStartDate = row.IsBatchNumber ? row.BatchStartDate : null

      row.HasGrammage = e.HasGrammage ?? false
      row.Grammage = e.Grammage ?? 0
      row.ProductNo = e.ProductNo
      row.ProductName = e.ProductName
      row.ProductId = e.ProductId
      row.ProductSpec = e.ProductSpec
      row.SaUnitId = e.SaUnitId
      row.SaUnitName = e.SaUnitName
      row.UnitId2 = e.UnitId2
      row.ColorId = null
      row.UseColor = e.UseColor
      row.Colors = e.Colors
      row.UnitId = e.SaUnitId
      row.Units = e.Units
      row.RetailPrice = 0
      row.UnitType = 0
      row.ChangeType = 0
      row.ExistQuantity = e.ExistQuantity
      row.StockQuantity = e.StockQuantity
      row.Amount = 0
      row.TaxLimit = 0
      row.TaxAmount = 0
      row.DiscountAmount = 0
      row.Discount = 100
      row.TaxRate = 0
      row.PropertyId = null
      row.PropertyName = ''
      row.PropertyNo = ''
      row.UseProcess = e.UseProcess
      row.TrademarkNo=e.TrademarkNo
      row.BarCode = e.ProductNo + '*0*0*0'
      if(row.TrademarkNo){
      row.BarCode = e.ProductNo + '*0*0'+ '*' + (row.TrademarkNo || 0)
      }
      // this.colorList = e.Colors;
      // this.optionList = e.Units;
      console.log('SaQuantity', Number(row.SaQuantity))
      // if (!Number(row.SaQuantity)) row.SaQuantity = 1;
      // if (e.UnitType === 0) {
      //   row.UnitId2 = e.SaUnitId;
      //   row.UnitName2 = e.SaUnitName;
      // }

      //

      if (e.Units.length === 0) {
        // row.UnitId2 = e.SaUnitId;
        // row.SaUnitName = e.SaUnitName;
        // row.UnitName = e.SaUnitName;
        // row.Rate = 1;
        row.UnitId2 = e.SaUnitId
        // row.PuUnitName = e.PuUnitName;
        row.UnitName = e.PuUnitName
        row.UnitId2 = 0
        row.SaUnitName = e.SaUnitName
        row.UnitName2 = ''
        row.Rate = 0
        row.Quantity2 = 0
      } else {
        row.UnitType = 1
        e.Units.forEach(item => {
          if (item.ChangeType == 1) row.ChangeType = item.ChangeType
        })
        if (row.SaUnitId) {
          let index = this.getUnitIndex(3, e.Units, row.SaUnitId)
          let data = this.getUnitValue(e.Units, index)
          let assistIndex = 0
          let assistData = {}
          row.IsMain = data.IsMain
          if (data.IsMain) {
            assistIndex = this.getUnitIndex(2, e.Units)
            assistData = this.getUnitValue(e.Units, assistIndex)
            row.Rate = this.getIinvexchrate(assistData.Rate)
          } else {
            assistIndex = this.getUnitIndex(1, e.Units)
            assistData = this.getUnitValue(e.Units, assistIndex)
            row.Rate = this.getIinvexchrate(data.Rate)
          }
          row.UnitId2 = assistData.UnitId
          row.UnitName2 = assistData.UnitName
        } else {
          let untiLength = e.Units.length
          let mainData = []
          let noMainData = []
          for (let i = 0; i < untiLength; ++i) {
            if (e.Units[i].IsMain) {
              mainData.push(e.Units[i])
            } else {
              noMainData.push(e.Units[i])
            }
          }
          row.SaUnitId = mainData[0].UnitId
          row.SaUnitName = mainData[0].UnitName
          row.UnitId2 = noMainData[0].UnitId
          row.UnitName2 = noMainData[0].UnitName
          row.Rate = this.getIinvexchrate(noMainData[0].Rate)
          row.IsMain = true
        }

        if (row.IsMain) {
          if (row.HasGrammage == true) {
            row.Quantity2 = this.getQuantity(row.SaQuantity * Number(row.Rate))
          } else {
            row.Quantity2 = this.getQuantity(row.SaQuantity / Number(row.Rate))
          }
        } else {
          if (row.HasGrammage == true) {
            row.Quantity2 = this.getQuantity(row.SaQuantity / Number(row.Rate))
          } else {
            row.Quantity2 = this.getQuantity(row.SaQuantity * Number(row.Rate))
          }
        }
        row.Amount = Number(row.Price ?? 0) * Number(row.SaQuantity ?? 0)
        row.TaxAmount = Number(row.Amount ?? 0) + Number(row.TaxLimit ?? 0)
      }
      // if (e.Units.length > 0) {
      //   const UnitIds = e.Units.map((i) => i.UnitId);
      //   const index =
      //     UnitIds.indexOf(e.SaUnitId) === e.Units.length
      //       ? 0
      //       : UnitIds.indexOf(e.SaUnitId) + 1;
      //   // row.UnitId2 = UnitIds[index];
      //   const saleData = e.Units.filter((i) => i.UnitId === e.SaUnitId)[0];
      //   const unitData = e.Units.filter((i) => i.UnitId === UnitIds[index])[0];
      //   // row.Rate = unitData.Rate / saleData.Rate;
      //   // row.Quantity2 = row.SaQuantity * row.Rate;
      //   row.UnitChangeType = unitData.ChangeType;
      // }
      let param = { ProductId: e.ProductId }
      let TradeUnitId = this.data.TradeUnitId

      console.log('param::', TradeUnitId ? (param[TradeUnitId] = TradeUnitId) : param)
      this.productApi.productPrice(TradeUnitId ? { ...param, TradeUnitId: this.data.TradeUnitId } : param).then(res => {
        if (res.Data) {
          row.SalePrice = res.Data.SalePrice
          row.RetailPrice = res.Data.RetailPrice
          row.PurchasePrice = res.Data.PurchasePrice
          row.QuotedPrice = res.Data.QuotationPrice
          row.Price = res.Data.QuotationPrice
          row.TaxPrice = res.Data.QuotationPrice
          if (res.Data.Discount > 0) {
            row.Discount = res.Data.Discount
          }
          this.changeQuotedPrice(row, index)
        }
      })

      this.api.minimumPrice(TradeUnitId ? { ...param, TradeUnitId: this.data.TradeUnitId } : param).then(res => {
        if (res.Data) {
          row.RetailPrice = res.Data.Price
        } else {
          this.$message.warning(res.msg)
        }
      })

      let _colorShow = this.tableList.find(item => item.UseColor == true)
      if (_colorShow) {
        this.tableColorShow = true
      } else {
        this.tableColorShow = false
      }
    },
    addColumn(row, column) {
      if (row.index === this.tableList.length - 1 && !this.ReviewStatus) {
        this.addList()
      }
    },
    // compareUnitId(data, row, index) {

    //   this.isMainUnitId2 = true;
    //   this.tableList[index].Rate = data.UnitId === row.SaUnitId ? 1 : data.Rate;
    //   row.UnitChangeType = data.ChangeType;
    //   if (data.ChangeType === 0) row.Quantity2 = row.SaQuantity * row.Rate;
    //   if (data.ChangeType === 1 && Number(row.Quantity2) != 0)
    //     row.Rate = row.Quantity2 / row.SaQuantity;
    // },
    // changeDeliveryDate(row) {
    //   if (row.T === 3) row.T = 1;
    // },
    // changeIsGift(data, row) {
    //   if (row.T === 3) row.T = 1;
    //   if (data) {
    //     row.QuotedPrice = 0;
    //     row.Discount = 0;
    //     row.TaxRate = 0;
    //     row.Price = 0;
    //     row.TaxPrice = 0;
    //     row.Amount = 0;
    //     row.TaxLimit = 0;
    //     row.TaxAmount = 0;
    //     row.DiscountAmount = 0;
    //   }
    // },
    compareUnitId(data, row, index) {
      if (row.T === 3) row.T = 1
      if (data.IsMain) {
        this.tableList[index].IsMain = false
      } else {
        this.tableList[index].IsMain = true
      }
      let findIndex = 0
      if (row.SaUnitId == row.UnitId2) {
        let num = 0
        num = row.SaQuantity
        row.SaQuantity = row.Quantity2
        row.Quantity2 = num
        if (this.tableList[index].IsMain == false) {
          //当前选择的主单位
          findIndex = this.getUnitIndex(2, this.tableList[index].Units)
          this.changeLeftUnitId(index, findIndex)
        } else {
          findIndex = this.getUnitIndex(1, this.tableList[index].Units)
          this.changeLeftUnitId(index, findIndex)
        }
      } else {
        if (this.tableList[index].IsMain == false) {
          //当前选择的主单位
          findIndex = this.getUnitIndex(2, this.tableList[index].Units)
          this.changeLeftUnitId(index, findIndex)
        } else {
          findIndex = this.getUnitIndex(1, this.tableList[index].Units)
          this.changeLeftUnitId(index, findIndex, data.Rate)
        }
      }
      this.changeQuantity2(this.tableList[index].Quantity2, row, index)
      row.Amount = row.SaQuantity * row.QuotedPrice
    },
    compareSaUnit(data, row, index) {
      if (row.T === 3) this.tableList[index].T = 1
      this.tableList[index].IsMain = data.IsMain
      let findIndex = 0
      if (row.SaUnitId == row.UnitId2) {
        let num = 0
        num = row.SaQuantity
        row.SaQuantity = row.Quantity2
        row.Quantity2 = num
        if (data.IsMain) {
          //当前选择的主单位
          findIndex = this.getUnitIndex(2, this.tableList[index].Units)
          this.changeRightUnitId(index, findIndex)
        } else {
          findIndex = this.getUnitIndex(1, this.tableList[index].Units)
          this.changeRightUnitId(index, findIndex)
        }
      } else {
        if (data.IsMain) {
          findIndex = this.getUnitIndex(2, this.tableList[index].Units)
          this.changeRightUnitId(index, findIndex)
        } else {
          findIndex = this.getUnitIndex(1, this.tableList[index].Units)
          this.changeRightUnitId(index, findIndex, data.Rate)
        }
      }
      this.changeQuantity(this.tableList[index].SaQuantity, row, index)
    },
    //传入数组 索引 返回对应的 id 和name index是table索引  findIndex 是当前主辅单位索引
    changeRightUnitId(index, findIndex, Rate = 0) {
      this.tableList[index].UnitId2 = this.tableList[index].Units[findIndex].UnitId
      this.tableList[index].UnitName2 = this.tableList[index].Units[findIndex].UnitName
      if (Rate > 0) {
        this.tableList[index].Rate = Rate
      }
    },
    // integerQuantity(row,index){
    //   if(this.data.MinusEntry){
    //         row.SaQuantity=0-row.SaQuantity
    //         row.Quantity2=0-row.Quantity2
    //   }else{
    //         row.SaQuantity=Math.abs(row.SaQuantity)
    //         row.Quantity2=Math.abs(row.Quantity2)
    //   }
    // },
    changeQuantity2(data, row, index, type = 1) {
      console.log(row.IsMain)
      if (data == '-' || data == '.' || data == '') {
        return
      }
      data = Number(this.getQuantity(data))
      ;``
      row.Quantity2 = data
      if (this.data.MinusEntry == 1) {
        row.SaQuantity > 0 ? (row.SaQuantity = 0 - row.SaQuantity) : row.SaQuantity
        row.Quantity2 > 0 ? (row.Quantity2 = 0 - row.Quantity2) : row.Quantity2
        data = data > 0 ? 0 - data : data
      } else if (this.data.MinusEntry == 0) {
        row.SaQuantity = Math.abs(row.SaQuantity)
        row.Quantity2 = Math.abs(row.Quantity2)
        data = Math.abs(data)
      }
      if (row.T === 3) row.T = 1
      if (type) {
        if (row.IsMain == false) {
          if (row.ChangeType == 1) {
            if (row.SaQuantity === '' || row.SaQuantity === 0) return
            if (row.HasGrammage == true) {
              row.SaQuantity = this.getQuantity(data * row.Rate)
            } else {
              row.Rate = this.getIinvexchrate(data / row.SaQuantity)
            }
          } else {
            console.log('数量1=数量2/换算率')
            row.SaQuantity = this.getQuantity(data / row.Rate)
          }
        } else {
          if (row.ChangeType == 1) {
            if (row.SaQuantity === '' || row.SaQuantity === 0) return
            if (row.HasGrammage == true) {
              row.SaQuantity = this.getQuantity(data / row.Rate)
            } else {
              row.Rate = this.getIinvexchrate(row.SaQuantity / data)
            }
          } else {
            console.log('数量1=数量2*换算率')
            row.SaQuantity = this.getQuantity(data * row.Rate)
          }
        }
      }
      row.Amount = row.SaQuantity * row.QuotedPrice
    },
    getChangeQuantity(data, row, index) {
      if (row.SaQuantity === '' || row.SaQuantity === 0) {
        if (row.Quantity2 && row.Rate) {
          if (row.IsMain) {
            if (row.HasGrammage == true) {
              row.SaQuantity = this.getQuantity(row.Quantity2 / Number(row.Rate))
            } else {
              row.SaQuantity = this.getQuantity(row.Quantity2 * Number(row.Rate))
            }
          } else {
            if (row.HasGrammage == true) {
              row.SaQuantity = this.getQuantity(row.Quantity2 * Number(row.Rate))
            } else {
              row.SaQuantity = this.getQuantity(row.Quantity2 / Number(row.Rate))
            }
          }
        }
      }
    },
    getUnitValue(arr, findIndex) {
      let data = {}
      data.UnitId = arr[findIndex].UnitId
      data.UnitName = arr[findIndex].UnitName
      data.IsMain = arr[findIndex].IsMain
      data.ChangeType = arr[findIndex].ChangeType
      data.Rate = arr[findIndex].Rate
      return data
    },
    //获取计量单位主辅单位的索引
    getUnitIndex(type, arr, id = '') {
      let index = 0
      if (type == 1) {
        //获取主单位索引
        index = arr.findIndex(el => el.IsMain == true)
      } else if (type == 2) {
        //获取数组第一个不是主单位的索引
        index = arr.findIndex(el => el.IsMain == false)
      } else {
        //获取当前传入id的索引
        index = arr.findIndex(el => id == el.UnitId)
      }
      return index
    },
    changeLeftUnitId(index, findIndex, Rate = 0) {
      this.tableList[index].SaUnitId = this.tableList[index].Units[findIndex].UnitId
      this.tableList[index].SaUnitName = this.tableList[index].Units[findIndex].UnitName
      if (Rate > 0) {
        this.tableList[index].Rate = Rate
      }
    },
    RestartOrder() {
      this.$message.success('新增')
      Object.assign(this.$data, this.$options.data.call(this))
      this.init()
      this.createOrder()
      // this.addList();

      setTimeout(() => {
        this.$refs.ruleForm.clearValidate()
      }, 30)
    },

    orderUpdate() {
      this.$message.success('变更')
      this.is_orderUpdateStatus = true
    },
    Review() {
      console.log('this.data.OrderId', this.data.DocId)
      this.api.review(this.data.DocId).then(res => {
        // this.data.Status = 2;
        res.Code === 0 ? this.$message.success(res.Msg) : this.$message.warning(res.Msg)

        if (res.Code === 0) {
          this.editOrder(this.data.DocId)
          // this.api.info(this.data.OrderId).then((res) => {
          //   this.data = res.Data;
          // });
        }
      })
    },
    orderReview() {
      if (this.data.DocId == 0) {
        this.$message.warning('订单未保存')
        return
      }

      if (this.isEdit) {
        this.$message.warning('订单已修改，请先保存')
        return
      }

      const message = this.data.Status == 2 ? '确认要弃审吗？ ' : '确认提交审核吗？'
      this.$confirm(message, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.isLoading = true
          const data = this.data.Status == 2 ? 'back' : 'review'
          if (data === 'review') {
            this.Review()
            // this.save(1);
          } else if (data === 'back') {
            this.api[data](this.data.DocId).then(res => {
              // if (res.Code === 0 && data == "review") {
              //   this.data.Status = 2;
              // }
              // if (res.Code === 0 && data == "back") this.data.Status = 0;
              res.Code === 0 ? this.$message.success(res.Msg) : this.$message.warning(res.Msg)

              if (res.Code === 0) {
                this.editOrder(this.data.DocId)
                // this.api.info(this.data.OrderId).then((res) => {
                //   this.data = res.Data;
                // });
              }
            })
          }
          // let ids = rows.map((item) => {
          //   return item.BusinessTypeId;
          // });
          // this.$refs.list.delRange(ids);
        })
        .catch(() => {})
    },
    orderDel() {
      // let rows = this.$refs.list.getCheckedRows();
      if (this.data.DocId == 0) {
        this.$message.warning('订单未保存')
        return
      }
      this.$confirm('确认删除所选的数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.api.delete({ Id: this.data.DocId }).then(res => {
            if (res.Code === 0) {
              this.RestartOrder()
              this.isEdit = false
            }
            res.Code === 0 ? this.$message.success(res.Msg) : this.$message.warning(res.Msg)
          })
          // let ids = rows.map((item) => {
          //   return item.BusinessTypeId;
          // });
          // this.$refs.list.delRange(ids);
        })
        .catch(() => {})
    },
    delTableList(data, index) {
      this.isEdit = true
      // if (data.isOrderData) {
      //   // this.data.TradeUnitId = '';
      //   this.data.FullName = '';
      //   this.isSelect = false;
      //   this.$nextTick(() => {
      //     this.$refs.ruleForm.clearValidate();
      //   })
      // }
      // this.$message.success("删除");
      this.tableList.splice(index, 1)
      if (this.tableList.length === 0) this.addList()
      if (this.tableList.length === 1) {
        this.isSelect = false
      }
    },
    openEmp() {
      this.$refs.empDialog.open().then(that => {
        that.getData()
      })
    },
    setEmp(data) {
      console.log(data)
      this.data.EmpId = data.EmpId
      this.data.EmpName = data.EmpName
      this.data.DpId = data.DpId
      this.data.DpName = data.DpName
      this.data.DpNo = data.DpNo
    },

    delRows() {
      let rows = this.$refs.list.getCheckedRows()
      if (rows.length == 0) {
        this.$message.warning('请选择要删除的数据')
        return
      }
      this.$confirm('确认删除所选的数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let ids = rows.map(item => {
            return item.PropertyId
          })
          this.$refs.list.delRange(ids)
        })
        .catch(() => {})
    },
    // openSales() {
    //   this.$refs.orderDialog.open();
    // },
    setTradeunit(data) {
      console.log(data, 'data')
      this.data.EmpId = data.EmpId
      this.data.EmpName = data.EmpName
      // this.data.TradeUnitId = data.TradeUnitId;
      this.data.FullName = data.FullName
      this.data.TradeUnitId = data.TradeUnitId
      this.data.TradeUnitType = data.TradeUnitType
    },
    // setTradeunit(data) {
    //   console.log(data, "data");
    //   // this.data.TradeUnitId = data.TradeUnitId;
    //   this.data.FullName = data.FullName;
    //   this.data.TradeUnitId = data.TradeUnitId;
    //   this.data.TradeUnitType = data.TradeUnitType;
    // },
    // 貌似需要审核后才可以进行 修改 行中止
    changeLineAbort(data, row) {
      if (this.data.DocId == 0 || row.OrderProductId == 0) return (row.LineAbort = false)
      this.api
        .lineAbort({
          Id: row.OrderProductId,
          IsLineAbort: data
        })
        .then(res => {
          if (res.Code === 1) {
            row.LineAbort = !data
            return this.$message.error(res.Msg)
          }
        })
    },
    async openDialog(type) {
      if (type === '销售订单') {
        this.title = '销售订单'
        this.bool = true
        const res = await this.sourceTypeApi.info('销货单')
        let OrderTypeFilter = res.SourceTypeId

        let that = await this.$refs.saleOrderSelect.open()
        if (this.data.FullName) {
          that.$refs.list.getData({
            TradeUnitName: this.data.FullName,
            OrderTypeFilter
          })
        } else {
          that.$refs.list.getData({ OrderTypeFilter })
        }
      } else if (type == '发货通知单') {
        this.title = '发货通知单'
        this.bool = false
        const res = await this.sourceTypeApi.info('销货单')
        let OrderType = res.SourceTypeId

        let that = await this.$refs.deliveryReleaseSelect.open()

        if (this.data.FullName) {
          that.$refs.list.getData({
            TradeUnitName: this.data.FullName,
            OrderType
          })
        } else {
          that.$refs.list.getData({ OrderType })
        }
      } else if (type == '销售出库单') {
        this.title = '销售出库单'
        this.bool = false
        const res = await this.sourceTypeApi.info('销货单')
        let OrderType = res.SourceTypeId

        let that = await this.$refs.selloutWarehouseSelect.open()
        that.setBypeId(this.data.BusinessTypeId)
        that.$refs.list.getData({
          Status: 2,
          TradeUnitName: this.data.FullName,
          BusinessTypeId: this.data.BusinessTypeId,
          OrderType
        })
      }
    },
     changeProperty(val, row, index) {
      if (row.T === 3) this.tableList[index].T = 1
      var pm = { ProductId: row.ProductId, ColorId: row.ColorId, PropertyId: row.PropertyId }
      if (this.data.WarehouseId) {
        pm.WarehouseId = this.data.WarehouseId
      }
      this.pdApi.stockInfo(pm).then(res => {
        if (res.Code == 0) {
          row.ExistQuantity = res.Data.AvailableQuantity
          row.StockQuantity = res.Data.StockQuantity
        }
      })

      row.PropertyNo = ''
      let item = this.propertyList.filter(item => {
        return item.PropertyId === val
      })[0]
      row.PropertyNo = item.PropertyNo
      row.PropertyName = item.PropertyName
      if (row.ProductId > 0) {
        row.BarCode = row.ProductNo + '*' + (row.ColorNo || 0) + '*' + (row.PropertyNo || 0) + '*' + (row.TrademarkNo || 0)
      }
    },
    changeColor(val, row, index) {
      if (row.T === 3) this.tableList[index].T = 1
      var pm = { ProductId: row.ProductId, ColorId: row.ColorId, PropertyId: row.PropertyId }
      if (this.data.WarehouseId) {
        pm.WarehouseId = this.data.WarehouseId
      }
      this.pdApi.stockInfo(pm).then(res => {
        if (res.Code == 0) {
          row.ExistQuantity = res.Data.AvailableQuantity
          row.StockQuantity = res.Data.StockQuantity
        }
      })
      row.colorNo = ''
      let item = this.colorList.filter(item => {
        return item.ColorId === val
      })[0]
      row.ColorNo = item.ColorNo
      row.ColorName = item.ColorName
      if (row.ProductId > 0) {
        row.BarCode = row.ProductNo + '*' + (row.ColorNo || 0) + '*' + (row.PropertyNo || 0)+ '*' + (row.TrademarkNo || 0)
      }
    },
    validInput(row, index, type) {
      if (row.T === 3) this.tableList[index].T = 1
      if (!Number(row.SaQuantity)) {
        this.$message.warning('请先填写数量')
        return true
      }
      return false
    },

    changeQuantity(data, row, index, type = 1) {
      if (data == '-' || data == '.' || data == '') {
        return
      }

      data = Number(this.getQuantity(data))
      row.SaQuantity = data

      if (row.T == 3) this.tableList[index].T = 1
      if (this.data.MinusEntry == 1) {
        row.SaQuantity > 0 ? (row.SaQuantity = 0 - row.SaQuantity) : row.SaQuantity
        row.Quantity2 > 0 ? (row.Quantity2 = 0 - row.Quantity2) : row.Quantity2
        data = data > 0 ? 0 - data : data
      } else if (this.data.MinusEntry == 0) {
        row.SaQuantity = Math.abs(row.SaQuantity)
        row.Quantity2 = Math.abs(row.Quantity2)
        data = Math.abs(data)
      }
      if (type) {
        // if (row.IsMain) {
        //   row.Quantity2 = this.getQuantity(row.SaQuantity / row.Rate);
        // } else {
        //   row.Quantity2 = this.getQuantity(row.SaQuantity * row.Rate);
        // }
        if (row.IsMain) {
          if (row.HasGrammage == true) {
            row.Quantity2 = this.getQuantity(row.SaQuantity * row.Rate)
          } else {
            row.Quantity2 = this.getQuantity(row.SaQuantity / row.Rate)
          }
        } else {
          if (row.HasGrammage == true) {
            row.Quantity2 = this.getQuantity(row.SaQuantity / row.Rate)
          } else {
            row.Quantity2 = this.getQuantity(row.SaQuantity * row.Rate)
          }
        }
      }
      // if (this.optionList.length === 0) row.Quantity2 = Number(row.SaQuantity);
      // if (this.optionList.length > 0 && row.UnitId2 != 0) {
      //   const mainList = this.optionList
      //     .filter((i) => i.IsMain)
      //     .map((sub) => sub.UnitId);
      //   if (mainList.includes(row.SaUnitId) && this.isMainUnitId2 == false)
      //     row.Quantity2 = row.SaQuantity / row.Rate;
      //   else if (!mainList.includes(row.SaUnitId) && this.isMainUnitId2 == true)
      //     row.Quantity2 = row.SaQuantity * row.Rate;
      //   else row.Quantity2 = Number(row.SaQuantity);
      // } else row.Quantity2 = Number(row.SaQuantity);

      // 金额
      // if (Number(row.Price)) {
      //let Amount = Number(row.Price) * data * (Number(row.Discount ?? 0) / 100);
      console.log(data, 'changeQuantity')
      let Amount = Number(row.Price) * data
      console.log(Amount, 'Amount')
      this.tableList[index].Amount = Number(Amount.toFixed(2))
      console.log(this.tableList[index].Amount, 'this.tableList[index].Amount')
      // }

      // 税额
      // if (Number(row.Price) && Number(row.TaxRate)) {
      let TaxLimit = Number(row.Price) * data * (Number(row.TaxRate) / 100)
      this.tableList[index].TaxLimit = Number(TaxLimit.toFixed(2))
      // }

      // 含税单价
      // if (Number(row.Price) && Number(row.TaxRate)) {
      let TaxPrice = (Number(row.Price) * (100 + Number(row.TaxRate))) / 100
      this.tableList[index].TaxPrice = Number(this.getPrice(TaxPrice))
      // }

      // 含税金额
      // if (Number(row.Amount) || Number(row.TaxLimit)) {
      let TaxAmount = Number(row.Amount ?? 0) + Number(row.TaxLimit ?? 0)
      this.tableList[index].TaxAmount = Number(TaxAmount.toFixed(2))
      // }

      // 折扣金额
      // if (Number(row.QuotedPrice) && Number(row.Price)) {
      let DiscountAmount = (Number(row.QuotedPrice) - Number(row.Price)) * Number(data)
      this.tableList[index].DiscountAmount = Number(DiscountAmount.toFixed(2))
      // }
    },
    // // 数量2
    // changeQuantity2(row, index) {
    //   console.log("输出", row.UnitChangeType);
    //   if (this.optionList.length === 0) return (row.SaQuantity = row.Quantity2);
    //   if (this.optionList.length > 0) {
    //     if (row.UnitChangeType == 0) {
    //       console.log("执行");
    //       row.SaQuantity = row.Quantity2 / row.Rate;
    //       return this.changeQuantity(row.SaQuantity, row, index);
    //     }
    //     if (row.UnitChangeType == 1) {
    //       return (row.Rate = row.Quantity2 / row.SaQuantity);
    //     }
    //   }
    // },
    // 报价
    changeQuotedPrice(row, index) {
      // row.QuotedPrice=parseFloat(row.QuotedPrice)
      if (!(row.QuotedPrice > 0)) row.QuotedPrice = 0
      if (row.T === 3) this.tableList[index].T = 1
      // this.changeDiscount(row, index);
      // 修改单价
      let Price = (row.Discount / 100) * row.QuotedPrice
      this.tableList[index].Price = Price < 0 ? 0 : this.getPrice(Price)

      //修改金额
      let Amount = Number(row.Price ?? 0) * Number(row.SaQuantity ?? 0)
      this.tableList[index].Amount = Number(Amount.toFixed(2))

      //修改含税单价
      // if (Number(row.Price) && Number(row.TaxRate)) {
      let TaxPrice = (Number(row.Price) * (100 + Number(row.TaxRate))) / 100
      this.tableList[index].TaxPrice = Number(this.getPrice(TaxPrice))
      // }

      // 折扣金额
      // if (Number(row.QuotedPrice) && Number(row.Price)) {
      let DiscountAmount = (Number(row.QuotedPrice) - Number(row.Price)) * Number(row.SaQuantity)
      this.tableList[index].DiscountAmount = Number(DiscountAmount.toFixed(2))
      // }

      // 税额
      // if (Number(row.Price) && Number(row.TaxRate)) {
      let TaxLimit = Number(row.Price) * Number(row.SaQuantity) * (Number(row.TaxRate) / 100)
      this.tableList[index].TaxLimit = Number(TaxLimit.toFixed(2))
      // }

      // 含税金额
      // if (Number(row.Amount) || Number(row.TaxLimit)) {
      let TaxAmount = Number(row.Amount ?? 0) + Number(row.TaxLimit ?? 0)
      this.tableList[index].TaxAmount = Number(TaxAmount.toFixed(2))
      // }

      // this.changeTaxRate(row, index);
    },
    // 折扣
    changeDiscount(row, index) {
      if (this.validInput(row, index, 'Discount')) return

      if (row.T == 3) this.tableList[index].T = 1
      // 修改单价
      let Price = (row.Discount / 100) * row.QuotedPrice
      this.tableList[index].Price = Price < 0 ? 0 : Number(this.getPrice(Price))

      //修改金额
      let Amount = Number(row.Price ?? 0) * Number(row.SaQuantity ?? 0)
      this.tableList[index].Amount = Number(Amount.toFixed(2))

      //修改含税单价
      if (Number(row.Price) && (Number(row.TaxRate) || row.TaxRate == 0)) {
        let TaxPrice = (Number(row.Price) * (100 + Number(row.TaxRate))) / 100
        this.tableList[index].TaxPrice = Number(this.getPrice(TaxPrice))
      }

      // 折扣金额
      if (Number(row.QuotedPrice) && Number(row.Price)) {
        let DiscountAmount = (Number(row.QuotedPrice) - Number(row.Price)) * Number(row.SaQuantity)
        this.tableList[index].DiscountAmount = Number(DiscountAmount.toFixed(2))
      }

      // 税额
      if (Number(row.Price) && Number(row.TaxRate)) {
        let TaxLimit = Number(row.Price) * Number(row.SaQuantity) * (Number(row.TaxRate) / 100)
        this.tableList[index].TaxLimit = Number(TaxLimit.toFixed(2))
      }

      // 含税金额
      if (Number(row.Amount) || Number(row.TaxLimit)) {
        let TaxAmount = Number(row.Amount ?? 0) + Number(row.TaxLimit ?? 0)
        this.tableList[index].TaxAmount = Number(TaxAmount.toFixed(2))
      }
    },
    // 单价
    changePrice(row, index) {
      if (this.validInput(row, index, 'Price')) return
      if (!(row.Price > 0)) row.Price = 0
      if (row.T == 3) this.tableList[index].T = 1
      row.Price = this.getPrice(row.Price)
      let quantityNum = 0
      if (!row.Units || row.Units.length === 0) {
        quantityNum = row.SaQuantity
      } else {
        if (row.IsMain) {
          quantityNum = row.SaQuantity
        } else {
          quantityNum = row.Quantity2
        }
      }
      row.quantityNum = quantityNum

      let rate = null

      if (row.QuotedPrice == 0 || row.QuotedPrice == null || row.QuotedPrice == '') {
        rate = this.tableList[index].Discount / 100
        if (rate === 1) {
          row.QuotedPrice = row.Price
        } else {
          row.QuotedPrice = Number((row.Price * row.Discount).toFixed(2))
        }
      } else {
        rate = (Number(row.Price) / Number(row.QuotedPrice)) * 100
        this.tableList[index].Discount = Number(rate.toFixed(2))
      }

      row.changeMode = 1

      // 修改单价
      let equation = null
      if (row.Discount == 100) {
        equation = Number(row.QuotedPrice)
      } else {
        equation = row.Price
      }

      // 金额
      // if (Number(row.quantityNum)) {
      console.log('row.quantityNum', row.quantityNum)
      let Amount = equation * Number(row.quantityNum)
      console.log('equation', equation)
      this.tableList[index].Amount = Number(Amount.toFixed(2))
      // }

      // 修改含税单价
      let TaxPrice = (equation * (100 + Number(row.TaxRate))) / 100
      this.tableList[index].TaxPrice = TaxPrice < 0 ? 0 : Number(this.getPrice(TaxPrice))

      // this.changeDiscount(row, index);

      // if (Number(row.QuotedPrice)) {
      // this.tableList[index].TaxPrice = Number(equation) < 0 ? 0 :  parseFloat(Number(equation).toFixed(2));
      // this.tableList[index].Price = equation < 0 ? 0 : equation.toFixed(2);

      // 折扣金额
      let DiscountAmount = 0
      DiscountAmount = (row.QuotedPrice - equation) * row.quantityNum

      this.tableList[index].DiscountAmount = Number(DiscountAmount.toFixed(2))

      // }
      // if (Number(row.TaxRate)) {

      let TaxLimit = equation * row.quantityNum * (row.TaxRate / 100)
      this.tableList[index].TaxLimit = TaxLimit < 0 ? 0 : Number(TaxLimit.toFixed(2))
      // this.changeTaxRate(row, index);
      // }

      // if (Number(row.TaxLimit) || Number(row.Amount)) {
      let TaxAmount = Number(row.Amount) + Number(row.TaxLimit ?? 0)
      this.tableList[index].TaxAmount = Number(TaxAmount.toFixed(2))
      // }
    },
    // 税率
    changeTaxRate(row, index) {
      if (this.validInput(row, index, 'TaxRate')) return
      if (row.T == 3) this.tableList[index].T = 1

      row.TaxRate = this.getIinvexchrate(row.TaxRate)
      // 修改税额
      let TaxLimit = Number(row.Price ?? 0) * Number(row.SaQuantity) * ((row.TaxRate ?? 0) / 100)
      this.tableList[index].TaxLimit = Number(TaxLimit.toFixed(2))

      // 修改含税单价
      let TaxPrice = (row.Price * (100 + Number(row.TaxRate))) / 100
      this.tableList[index].TaxPrice = TaxPrice < 0 ? 0 : Number(this.getPrice(TaxPrice))

      // 含税金额
      let TaxAmount = Number(row.Amount ?? 0) + Number(row.TaxLimit ?? 0)
      this.tableList[index].TaxAmount = Number(TaxAmount.toFixed(2))
    },
    // 含税单价
    changeTaxPrice(row, index) {
      if (this.validInput(row, index, 'TaxPrice')) return
      if (row.T == 3) this.tableList[index].T = 1
      // 修改单价
      let Price = row.TaxPrice / (1 + row.TaxRate / 100)
      this.tableList[index].Price = Number(this.getPrice(Price))

      // 修改折扣率
      if (row.QuotedPrice) {
        let rate = (Number(row.Price) / Number(row.QuotedPrice)) * 100
        this.tableList[index].Discount = Number(rate.toFixed(2))
      } else {
        this.tableList[index].Discount = 100
      }

      // 修改金额
      let Amount = Number(row.Price) * Number(row.SaQuantity) * (row.Discount / 100)
      this.tableList[index].Amount = Number(Amount.toFixed(2))

      // 折扣金额
      let DiscountAmount = 0
      DiscountAmount = (row.QuotedPrice - Number(row.Price)) * row.SaQuantity
      this.tableList[index].DiscountAmount = Number(DiscountAmount.toFixed(2))

      // if (Number(row.TaxRate)) {
      let TaxLimit = Number(row.Price) * Number(row.SaQuantity) * (Number(row.TaxRate) / 100)
      this.tableList[index].TaxLimit = TaxLimit < 0 ? 0 : Number(TaxLimit.toFixed(2))
      // this.changeTaxRate(row, index);
      // }

      // if (Number(row.TaxLimit) || Number(row.Amount)) {
      let TaxAmount = Number(row.Amount) + Number(row.TaxLimit)
      this.tableList[index].TaxAmount = Number(TaxAmount.toFixed(2))
      // }

      // this.changePrice(row, index)
    },
    // 税额
    changeTaxLimit(row, index) {
      if (this.validInput(row, index, 'TaxLimit')) return

      if (row.T == 3) this.tableList[index].T = 1

      if (row.changeMode === 0 || row.changeMode == null) {
        // 修改金额
        let Amount = Number(row.TaxAmount) - Number(row.TaxLimit)
        this.tableList[index].Amount = Number(Amount.toFixed(2))

        // 修改单价
        let Price = Number(row.Amount) / Number(row.SaQuantity)
        this.tableList[index].Price = Number(this.getPrice(Price))

        // this.changePrice(row, index)

        // 修改折扣率
        if (row.QuotedPrice) {
          let rate = (Number(row.Price) / Number(row.QuotedPrice)) * 100
          this.tableList[index].Discount = Number(rate.toFixed(2))
        } else {
          this.tableList[index].Discount = 100
        }

        // 修改含税单价
        let TaxPrice = (Number(row.Price) * (100 + Number(row.TaxRate ?? 0))) / 100
        this.tableList[index].TaxPrice = TaxPrice < 0 ? 0 : Number(this.getPrice(TaxPrice))

        // 折扣金额
        let DiscountAmount = 0
        DiscountAmount = (row.QuotedPrice - Number(row.Price)) * row.SaQuantity
        this.tableList[index].DiscountAmount = Number(DiscountAmount.toFixed(2))

        // 修改含税金额
        // if (Number(row.TaxLimit) || Number(row.Amount)) {
        let TaxAmount = Number(row.Amount) + Number(row.TaxLimit)
        this.tableList[index].TaxAmount = Number(TaxAmount.toFixed(2))
        // }
      } else {
        // 修改含税金额
        let TaxAmount = Number(row.Amount) + Number(row.TaxLimit)
        this.tableList[index].TaxAmount = Number(TaxAmount.toFixed(2))

        // 修改含税单价
        let TaxPrice = Number(row.TaxAmount) / Number(row.SaQuantity)
        this.tableList[index].TaxPrice = Number(this.getPrice(TaxPrice))
      }
    },
    // 金额
    changeAmount(row, index) {
      if (this.validInput(row, index, 'Amount')) return

      if (row.T == 3) this.tableList[index].T = 1

      // 修改单价
      let Price = Number(row.Amount) / Number(row.SaQuantity)
      this.tableList[index].Price = Number(this.getPrice(Price))

      // 修改报价
      if (Number(this.tableList[index].Discount) === 100) {
        row.QuotedPrice = this.tableList[index].Price
      }

      // 修改折扣率
      if (row.QuotedPrice) {
        let rate = (Number(row.Price) / Number(row.QuotedPrice)) * 100
        this.tableList[index].Discount = Number(rate.toFixed(2))
      } else {
        this.tableList[index].Discount = 100
      }

      // 折扣金额
      let DiscountAmount = 0
      DiscountAmount = (row.QuotedPrice - Number(row.Price)) * row.SaQuantity
      this.tableList[index].DiscountAmount = Number(DiscountAmount.toFixed(2))

      // this.changePrice(row, index)
      // 修改含税单价
      // if (Number(row.TaxRate)) {
      let TaxPrice = (Number(row.Price) * (100 + Number(row.TaxRate))) / 100
      this.tableList[index].TaxPrice = TaxPrice < 0 ? 0 : Number(this.getPrice(TaxPrice))
      // }

      // 修改税额
      // if (Number(row.TaxRate)) {
      let TaxLimit = Number(row.Price) * Number(row.SaQuantity) * (row.TaxRate / 100)
      this.tableList[index].TaxLimit = TaxLimit < 0 ? 0 : Number(TaxLimit.toFixed(2))
      // this.changeTaxRate(row, index);
      // }

      // 修改含税金额
      // if (Number(row.TaxLimit) || Number(row.Amount)) {
      let TaxAmount = Number(row.Amount) + Number(row.TaxLimit)
      this.tableList[index].TaxAmount = Number(TaxAmount.toFixed(2))
      // }
    },
    // 含税金额
    changeTaxAmount(row, index) {
      if (this.validInput(row, index, 'TaxAmount')) return

      if (row.T == 3) this.tableList[index].T = 1

      row.changeMode = 0

      // 修改金额
      let Amount = Number(row.TaxAmount) - Number(row.TaxLimit)
      this.tableList[index].Amount = Number(Amount.toFixed(2))

      // 修改单价
      let Price = Number(row.Amount) / Number(row.SaQuantity)
      this.tableList[index].Price = Number(this.getPrice(Price))

      // 修改折扣率
      if (row.QuotedPrice) {
        let rate = (Number(row.Price) / Number(row.QuotedPrice)) * 100
        this.tableList[index].Discount = Number(rate.toFixed(2))
      } else {
        this.tableList[index].Discount = 100
      }

      // 修改含税单价
      let TaxPrice = Number(row.TaxAmount) / Number(row.SaQuantity)
      this.tableList[index].TaxPrice = TaxPrice < 0 ? 0 : Number(this.getPrice(TaxPrice))

      // 折扣金额
      let DiscountAmount = 0
      DiscountAmount = (row.QuotedPrice - Number(row.Price)) * row.SaQuantity
      this.tableList[index].DiscountAmount = Number(DiscountAmount.toFixed(2))
    },
    // 折扣金额
    changeDiscountAmount(row, index) {
      if (this.validInput(row, index, 'DiscountAmount')) return

      if (row.T == 3) this.tableList[index].T = 1

      // 修改单价
      let Price = row.QuotedPrice - row.DiscountAmount / row.SaQuantity
      this.tableList[index].Price = Number(this.getPrice(Price))

      // 修改折扣率
      if (row.QuotedPrice) {
        let rate = (Number(row.Price) / Number(row.QuotedPrice)) * 100
        this.tableList[index].Discount = Number(rate.toFixed(2))
      } else {
        this.tableList[index].Discount = 100
      }

      // 金额
      let Amount = Number(row.Price) * Number(row.SaQuantity) * (Number(row.Discount) / 100)
      this.tableList[index].Amount = Number(Amount.toFixed(2))

      // 修改含税单价
      // if (Number(row.TaxRate)) {
      let TaxPrice = (Number(row.Price) * (100 + Number(row.TaxRate))) / 100
      this.tableList[index].TaxPrice = TaxPrice < 0 ? 0 : Number(this.getPrice(TaxPrice))
      // }

      // 修改税额
      // if (Number(row.TaxRate)) {
      let TaxLimit = Number(row.Price) * Number(row.SaQuantity) * (row.TaxRate / 100)
      this.tableList[index].TaxLimit = TaxLimit < 0 ? 0 : Number(TaxLimit.toFixed(2))
      // this.changeTaxRate(row, index);
      // }

      // 修改含税金额
      // if (Number(row.TaxLimit) || Number(row.Amount)) {
      let TaxAmount = Number(row.Amount) + Number(row.TaxLimit)
      this.tableList[index].TaxAmount = Number(TaxAmount.toFixed(2))
      // }
    },
    // 单价弹窗
    renderHeader(h, { column }) {
      return h('div', [
        h('span', column.label),
        h('i', {
          class: 'el-icon-s-order',
          style: 'font-size:14px;cursor: pointer;',
          on: {
            click: this.openSales
          }
        })
      ])
    },
    openPrint() {
      this.columnkey = saleList.Data.map(i => i.tableName)
      this.columns = saleList.Data.reduce((acc, item) => {
        let print = { ...item.print, key: item.tableName, label: item.label }
        acc.push({ label: item.label, data: print })
        return acc
      }, [])
      this.formData = saleList.Data.reduce((acc, item) => {
        return acc.concat({
          key: item.tableName,
          label: item.label,
          value: this.data[item.tableName]
        })
      }, [])
      this.$refs.printDialog.open()
      s
    },
    save(type = 0) {
      this.$refs.ruleForm.validate(valid => {
        console.log('valid', valid)
        if (!valid) return false

        if (this.data.SettleId === 2 && this.data.ReceiptAmount === 0) {
          this.$message.warning('收款方式为全额现结时，现结金额必填')
          return
        }

        var cacheData = {
          data: JSON.parse(JSON.stringify(this.data)),
          tableList: JSON.parse(JSON.stringify(this.tableList))
        }

        const Product = JSON.parse(JSON.stringify(this.data.Products))
        const TableList = JSON.parse(JSON.stringify(this.tableList))
        // 清除没有产品的数据

        /** 排序 */
        this.tableList = this.tableList.map((item, index) => {
          let snCode = (index + 1).toString().padStart(3, '0')
          return {
            ...item,
            SnCode: snCode
          }
        })

        var btId = 0
        var obj = this.businessTypeList.find(x => x.BusinessType == '销售退货')
        if (obj) btId = obj.BusinessTypeId

        this.tableList = this.tableList.filter(i => i.ProductId != 0)
        for (let i = 0; i <= this.tableList.length - 1; i++) {
          if (this.data.BusinessTypeId == btId && btId) {
            if (this.tableList[i].Amount > 0) {
              this.$message({ type: 'warning', message: '金额不能大于0' })
              return
            }
          } else {
            if (this.tableList[i].Amount < 0) {
              this.$message({ type: 'warning', message: '金额不能小于0' })
              return
            }
          }
          if (this.tableList[i].SaQuantity == null || this.tableList[i].SaQuantity == 0) return this.$message.warning('数量不能为空并且不为0')
          if (this.tableList[i].Units.length > 0 && this.tableList[i].UnitId2 == null) return this.$message.warning('计量单位2不能为空')
          if (this.tableList[i].UseColor && (this.tableList[i].ColorId === 0 || this.tableList[i].ColorId == null)) {
            this.$message.error(`存货${this.tableList[i].ProductName}未填写颜色`)
            return
          }
        }
        // if (this.tableList.filter((i) => i.DeliveryDate == "").length !== 0)
        //   return this.$message.warning("交货日期不能为空");
        //
        if (this.deleteDateList.length > 0) this.data.Receipts = this.data.Receipts.concat(this.deleteDateList)
        if (this.data.Products.length > 0) {
          // let delIds = this.tableList.map((item) => item.ProductId);
          // let delList = this.data.Products.reduce((arr, item) => {
          //   if (!delIds.includes(item.ProductId)) arr.push({ ...item, T: 2 });
          //   return arr;
          // }, []);
          let delList = []
          var delIds = this.tableList.map(x => {
            return x.DocProductId
          })
          this.data.Products.forEach(e => {
            let p = delIds.indexOf(e.DocProductId)
            if (p == -1) {
              delList.push({ ...e, T: 2 })
            }
          })
          //----------

          let addIds = this.data.Products.map(item => item.DocProductId)
          let addList = []
          addList = this.tableList.reduce((arr, item) => {
            if (!addIds.includes(item.DocProductId)) arr.push({ ...item, T: 0 })
            return arr
          }, [])

          let updateList = this.data.Products.filter(i => i.T == 1)
          this.data.Products = [...addList, ...delList, ...updateList]
        } else this.data.Products = this.tableList
        //
        this.data.DeliveryDate = this.data.DocDate
        this.data.Receipts = this.data.Receipts.filter(i => i.T !== null)

        //  T： 0-新增 1-修改 2-删除   处理编辑后删除只保留删除行的数据
        let tempArr = []
        for (const tempArrElement of this.data.Products) {
          /** 加入之前看看 id是否存在 */
          if (tempArr.find(item => item.DocProductId == tempArrElement.DocProductId)) {
            /** 如果存在 ，且type 相同*/
            if (tempArr.find(item => item.DocProductId == tempArrElement.DocProductId && item.T == tempArrElement.T)) {
              tempArr.push(tempArrElement)
              continue
            }
            /** 如果存在 ，且type 不同*/
            if (tempArr.find(item => item.DocProductId == tempArrElement.DocProductId && item.T != tempArrElement.T)) {
              if (tempArrElement.T == '2') {
                tempArr.forEach((y, index) => {
                  if (y.id == tempArrElement.id) {
                    tempArr[index] = tempArrElement
                  }
                })
              }
              continue
            }
          }
          tempArr.push(tempArrElement)
        }
        this.data.Products = tempArr
        console.log('保存前', this.data.Products)
        // console.log("保存前", this.data);
        // var data = this.$commonJs.obj.removeNullKey(this.data);
        // this.data.Requirement = "";
        // this.data.WarehouseId?this.data.WarehouseId:0
        // this.data.SettleId?this.data.SettleId:0
        if (this.data.SettleId == null) this.data.SettleId = 0
        if (this.data.InvoiceTypeId == null) this.data.InvoiceTypeId = 0
        if (this.data.WarehouseId == null) this.data.WarehouseId = 0
        if (this.data.BusinessTypeId == null) this.data.BusinessTypeId = 0
        this.data.Products.forEach((item, index) => {
          if (item.ColorId == null) {
            item.ColorId = 0
          }
          if (item.Amount == 0 && item.Price > 0 && item.SaQuantity > 0 && item.Discount > 0) {
            item.Amount = Number(((item.Price * item.SaQuantity * item.Discount) / 100).toFixed(2))
          }
        })

        /** 排序 */
        let ProductsSN = this.tableList.map((item, index) => {
          let snCode = (index + 1).toString().padStart(3, '0')
          return {
            DocProductId: item.DocProductId,
            SnCode: snCode
          }
        })

        var data = {
          ...this.data,
          InvoiceTypeId: this.data.InvoiceTypeId || 0,
          WarehouseId: this.data.WarehouseId || 0,
          SettleId: this.data.SettleId || 0,
          ProductsSN
        }
        // 等于空设置为0
        data.Products.forEach(item => {
          Object.keys(item).forEach(key => {
            if (item[key] == null && key !== 'LineAbortDate' && key !== 'DeliveryDate' && key !== 'Remark' && key !== 'BatchStartDate' && key !== 'BatchNumber' && key !== 'BarCode') {
              item[key] = 0
            }
          })
        })

        localStorage.setItem('business_sales_sale', JSON.stringify(cacheData))
        this.api
          .save(data)
          .then(res => {
            if (res.Code === 0) {
              const id = res.Data === 0 ? this.data.DocId : res.Data
              this.isSave = true
              this.isClickSave = true
              this.is_orderUpdateStatus = false
              this.editOrder(id, type)
              this.deleteDateList = []
              if (type !== 1) {
                this.$message.success('保存成功')
                this.isEdit = false
                if (this.$route.meta.data) {
                  this.$route.meta.data.isEdit = false
                }
                localStorage.removeItem('business_sales_sale')
              }
              this.data.Receipts = []
            } else {
              this.tableList = TableList
              this.data.Products = Product
              this.ProductModels = Product
              this.$message.error(res.Msg)
            }
          })
          .catch(err => {
            this.tableList = TableList
            this.data.Products = Product
            this.ProductModels = Product
          })
      })
    },
    editT(row) {
      if (row.T !== 0) row.T = 1
    },
    addList() {
      this.tableList.push({
        T: 0,
        StockQuantity: null,
        ExistQuantity: null,
        DocProductId: 0,
        OrderId: 0,
        SourceDocId: 0,
        SourceDtsId: 0,
        SourceType: 0,
        OrderProductId: 0,
        WarehouseId: this.data.WarehouseId ?? '',
        ProductId: 0,
        ColorId: null,
        SaUnitId: 0,
        SaQuantity: null,
        UnitId2: 0,
        Quantity2: null,
        Rate: null,
        QuotedPrice: null,
        Discount: 100,
        TaxRate: null,
        Price: null,
        TaxPrice: null,
        Amount: null,
        TaxAmount: null,
        TaxLimit: null,
        DiscountAmount: null,
        DeliveryDate: '',
        IsGift: false,
        CostPrice: null,
        CostAmount: null,
        OutQuantity: null,
        OutQuantity2: null,
        InvoicedQuantity: null,
        InvoicedQuantity2: null,
        ReturnQuantity: null,
        SettlementAmount: null,
        // 后端补充
        PriceStrategyId: null,
        ReceiptAmount: null,
        ProductNo: '',
        ProductType: 0,
        ProductName: '',
        ShortName: '',
        ProductSpec: '',
        Property: '',
        ImgUrl: '',
        ColorName: '',
        WarehouseNo: '',
        WarehouseName: '',
        SaUnitName: '',
        UnitName: '',
        DocNo: '',
        OrderNo: '',
        SourceDocNo: '',
        Remark: '',
        WarehousePositionId: null,
        WarehousePositionName: null,
        WarehousePositionList: [],
        BatchNumber: '',
        HasGrammage: false,
        Grammage: null,
        PropertyId:null,
        PropertyNo:'',
        ColorNo:'',
        PropertyName:''
      })
    },
    summaryFunc(param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        if (column.property === 'WarehouseId' || column.property === 'PackingSpeciId' || column.property === 'RealPackingNumber' || column.property === 'PackingNumber') {
          sums[index] = ''
          return
        }
        const values = data.map(item => Number(item[column.property]))
        if (!values.every(value => isNaN(value))) {
          var v = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
          //数量 getQuantity
          const arr1 = ['SaQuantity', 'Quantity2']
          //金额 固定2位小数
          const arr2 = ['Amount', 'TaxLimit', 'TaxAmount', 'DiscountAmount', 'CostPrice', 'CostAmount']
          if (arr1.indexOf(column.property) != -1) {
            v = this.getQuantity(v)
          }
          if (arr2.indexOf(column.property) != -1) {
            v = v.toFixed(2)
            let vStr = v.toString().split('.')
            if (Number(vStr[1]) <= 0) v = vStr[0]
          }
          if (v > 0) {
            v = Number(v).toLocaleString()
          }
          sums[index] = v
        } else {
          sums[index] = ''
        }
      })
      return sums
    },
    /** 打开批号弹框 */
    onOpenBatch(e, row, index) {
      this.batchPageParams.pageIndex = 1
      let o = {
        IsInOut: 1,
        WarehouseId: row.WarehouseId,
        ProductId: row.ProductId,
        PropertyId: row.PropertyId,
        ColorId: row.colorId,
        pageIndex: 1,
        pageSize: 7
      }
      var params = this.$commonJs.obj.removeNullKey(o)
      this.pdApi.productBatchNumberList(params).then(res => {
        if (res.Code == 0) {
          this.batchList = res.Data.map(item => {
            return {
              ...item,
              BatchStartDate: this.$commonJs.toDateString(item.BatchStartDate),
              ExpireDate: this.$commonJs.toDateString(item.ExpireDate)
            }
          })
          this.batchListTotal = res.Count
        } else {
          this.$message.error(res.Msg)
        }
      })
    },
    /** 选择批号 */
    onSelBatch(e, row, index, type) {
      if (row.T !== 0) {
        row.T = 1
      }
      if (e.BatchNumber !== row.BatchNumber) {
        row.BatchNumber = e.BatchNumber
        row.StockQuantity = e.BaseQuantity
      }
    },
    /** 输入批号 */
    inputTextBatch(text, row) {
      if (row.T !== 0) {
        row.T = 1
      }
      row.BatchNumber = text
      //IsInOut 入库-0 出库-1
      let o = {
        IsInOut: 1,
        WarehouseId: row.WarehouseId,
        ProductId: row.ProductId,
        PropertyId: row.PropertyId,
        ColorId: row.colorId,
        BatchNumber: row.BatchNumber,
        pageIndex: 1,
        pageSize: 7
      }
      var params = this.$commonJs.obj.removeNullKey(o)
      this.pdApi.productBatchNumberList(params).then(res => {
        if (res.Code == 0) {
          this.batchList = res.Data.map(item => {
            return {
              ...item,
              BatchStartDate: this.$commonJs.toDateString(item.BatchStartDate),
              ExpireDate: this.$commonJs.toDateString(item.ExpireDate)
            }
          })
          this.batchListTotal = res.Count
        } else {
          this.$message.error(res.Msg)
        }
      })
    },
    /** 批号下一页 */
    currentPageBatch({ val, text1 }, row) {
      this.batchPageParams.pageIndex = val
      let o = {
        IsInOut: 1,
        WarehouseId: row.WarehouseId,
        ProductId: row.ProductId,
        PropertyId: row.PropertyId,
        ColorId: row.colorId,
        ProductName: row.ProductName,
        pageIndex: val,
        pageSize: 7
      }
      var params = this.$commonJs.obj.removeNullKey(o)
      this.pdApi.productBatchNumberList(params).then(res => {
        if (res.Code == 0) {
          this.batchList = res.Data.map(item => {
            return {
              ...item,
              BatchStartDate: this.$commonJs.toDateString(item.BatchStartDate),
              ExpireDate: this.$commonJs.toDateString(item.ExpireDate)
            }
          })
          this.batchListTotal = res.Count
        } else {
          this.$message.error(res.Msg)
        }
      })
    },
    /** 批号起始日期 */
    changeBatchStartDate(row) {
      if (row.T !== 0) {
        row.T = 1
      }
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .navbar-group {
  margin-bottom: 20px;

  .el-button {
    margin-left: 4px;
  }
}

.not-edit {
  display: inline-block;
  min-width: 190px;
  text-align: center;
  // border-bottom: 1px solid #e4e7ed;
}

.dropdown-item {
  padding: 5px 10px;
}

// /deep/ .tableList .el-select .el-input__inner {
//   //margin-top: 10px;
//   border: none;
//   border-bottom: 1px solid #e4e7ed;
// }
</style>
